export const EmailSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={17}
		fill="none"
	>
		<path
			fill="currentColor"
			d="M1.5 16.5a1.438 1.438 0 0 1-1.05-.45A1.438 1.438 0 0 1 0 15V2A1.439 1.439 0 0 1 .45.95 1.439 1.439 0 0 1 1.5.5h17A1.538 1.538 0 0 1 20 2v13a1.538 1.538 0 0 1-1.5 1.5h-17ZM10 8.95 1.5 3.375V15h17V3.375L10 8.95Zm0-1.5L18.4 2H1.625L10 7.45Z"
		/>
	</svg>
);

export const InviteSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={16}
		fill="none"
	>
		<path
			fill="#27272E"
			d="M1.5 16.5a1.438 1.438 0 0 1-1.05-.45A1.438 1.438 0 0 1 0 15V2A1.439 1.439 0 0 1 .45.95 1.439 1.439 0 0 1 1.5.5h17A1.538 1.538 0 0 1 20 2v13a1.538 1.538 0 0 1-1.5 1.5h-17ZM10 8.95 1.5 3.375V15h17V3.375L10 8.95Zm0-1.5L18.4 2H1.625L10 7.45Z"
		/>
	</svg>
);

export const PasswordSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={23}
		fill="none"
	>
		<path
			fill="#27272E"
			d="M2.19 22.5a1.564 1.564 0 0 1-1.57-1.571V9.562A1.565 1.565 0 0 1 2.19 7.99h1.83V5.476a4.8 4.8 0 0 1 1.453-3.523A4.8 4.8 0 0 1 9 .5a4.8 4.8 0 0 1 3.52 1.454 4.801 4.801 0 0 1 1.453 3.523V7.99h1.836a1.565 1.565 0 0 1 1.571 1.57V20.93a1.566 1.566 0 0 1-1.57 1.57H2.19Zm0-1.571h13.62V9.562H2.19v11.367ZM9 17.262a1.967 1.967 0 0 0 1.427-.576 1.873 1.873 0 0 0 .592-1.386 2.062 2.062 0 0 0-.589-1.427 1.908 1.908 0 0 0-2.855 0 2.062 2.062 0 0 0-.589 1.427 1.87 1.87 0 0 0 .59 1.388A1.968 1.968 0 0 0 9 17.262ZM5.6 7.99h6.81V5.476a3.4 3.4 0 0 0-6.8 0L5.6 7.99Z"
		/>
	</svg>
);

export const CloseSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={17}
		fill="none"
	>
		<path
			fill="#040707"
			d="M16 1.678 14.389.068 8 6.455 1.611.067 0 1.678l6.389 6.39L0 14.455l1.611 1.611L8 9.678l6.389 6.39L16 14.455 9.611 8.067 16 1.678Z"
		/>
	</svg>
);

export const UsersSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={17}
		fill="none"
	>
		<path
			fill="#FFF"
			d="M0 17v-2.133a2.725 2.725 0 0 1 .463-1.558c.317-.465.76-.83 1.277-1.053 1.078-.475 2.19-.87 3.326-1.179a13.377 13.377 0 0 1 3.382-.393 13.087 13.087 0 0 1 3.34.393 23.95 23.95 0 0 1 3.312 1.18c.518.222.96.587 1.277 1.052.31.46.471 1.004.463 1.558V17H0Zm18.695 0v-2.077a4.26 4.26 0 0 0-.7-2.512 5.619 5.619 0 0 0-1.825-1.642c.956.142 1.902.339 2.835.59.778.196 1.53.479 2.246.841.516.276.959.67 1.291 1.151.317.463.483 1.012.477 1.572V17h-4.324ZM8.45 8.44a3.6 3.6 0 0 1-3.733-3.734A3.584 3.584 0 0 1 5.77 2.04 3.657 3.657 0 0 1 8.45 1 3.622 3.622 0 0 1 11.1 2.04a3.585 3.585 0 0 1 1.053 2.666A3.6 3.6 0 0 1 8.448 8.44h.001Zm8.842-3.734a3.657 3.657 0 0 1-1.039 2.681 3.585 3.585 0 0 1-2.667 1.053 3.08 3.08 0 0 1-.814-.112 4.634 4.634 0 0 0 .9-1.586 6.323 6.323 0 0 0 .31-2.035c.01-.669-.1-1.334-.324-1.965a6.553 6.553 0 0 0-.884-1.628c.128-.04.26-.069.393-.084.14-.018.28-.027.421-.028a3.557 3.557 0 0 1 3.705 3.705Zm-16 11.032H15.58v-.87c0-.3-.088-.592-.253-.842a1.7 1.7 0 0 0-.73-.618c-1-.478-2.043-.859-3.116-1.137a13.037 13.037 0 0 0-3.032-.323 13.177 13.177 0 0 0-3.06.323 17.25 17.25 0 0 0-3.116 1.137 1.7 1.7 0 0 0-.73.618c-.165.25-.253.543-.253.842l.002.87Zm7.13-8.56a2.4 2.4 0 0 0 2.47-2.47 2.364 2.364 0 0 0-.7-1.74 2.4 2.4 0 0 0-1.768-.7 2.4 2.4 0 0 0-2.442 2.441A2.4 2.4 0 0 0 7.48 7.006c.3.12.62.178.942.17v.001Z"
		/>
	</svg>
);

export const IntegrationsSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={22}
		fill="none"
	>
		<path
			fill="#FFF"
			d="M0 22v-7.136h3.385v-4.513h5.838V7.136H5.838V0h8.067v7.136h-3.384v3.215h5.838v4.513h3.385V22h-8.039v-7.136h3.385v-3.215H4.654v3.215h3.385V22H0ZM7.136 5.838h5.472V1.269H7.136v4.569ZM1.269 20.731h5.5v-4.569h-5.5v4.569Zm11.705 0h5.5v-4.569h-5.5v4.569Z"
		/>
	</svg>
);

export const SubscriptionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
	>
		<path
			fill="#FFF"
			d="M10 20a9.036 9.036 0 0 1-4.909-1.5 13 13 0 0 1-3.727-3.432v3.114H0v-5.455h5.455v1.364H2.341c.875 1.265 2 2.337 3.307 3.148A7.906 7.906 0 0 0 10 18.636a8.368 8.368 0 0 0 3.352-.682 8.66 8.66 0 0 0 4.6-4.6c.457-1.059.69-2.2.684-3.354H20a9.708 9.708 0 0 1-.784 3.886c-1.02 2.4-2.93 4.31-5.33 5.33A9.708 9.708 0 0 1 10 20Zm-.659-3.477V15.3a4.234 4.234 0 0 1-1.716-.875 4.758 4.758 0 0 1-1.17-1.648l1.16-.386c.162.55.501 1.029.965 1.364.46.333 1.013.508 1.58.5a2.481 2.481 0 0 0 1.511-.443 1.384 1.384 0 0 0 .6-1.17 1.63 1.63 0 0 0-.568-1.26 7.892 7.892 0 0 0-2.09-1.149A6.606 6.606 0 0 1 7.567 9a2.351 2.351 0 0 1-.682-1.773 2.362 2.362 0 0 1 .682-1.7 3.026 3.026 0 0 1 1.818-.864V3.5h1.25v1.16c.54.046 1.057.234 1.5.544.441.324.793.754 1.023 1.25l-1.09.523a2.488 2.488 0 0 0-.842-.955 2.154 2.154 0 0 0-1.182-.322c-.5-.028-.994.116-1.4.41a1.35 1.35 0 0 0-.51 1.113 1.364 1.364 0 0 0 .59 1.16 9.754 9.754 0 0 0 1.91.976c.83.302 1.589.774 2.226 1.386a2.7 2.7 0 0 1 .66 1.886c.004.358-.064.714-.2 1.045-.133.312-.33.59-.58.818-.271.24-.583.429-.92.557a4.556 4.556 0 0 1-1.228.284v1.182l-1.252.006ZM.001 10a9.708 9.708 0 0 1 .783-3.886c1.02-2.4 2.93-4.31 5.33-5.33A9.708 9.708 0 0 1 10 0a9.036 9.036 0 0 1 4.91 1.5 13 13 0 0 1 3.726 3.432V1.818H20v5.455h-5.455V5.91h3.114a11.257 11.257 0 0 0-3.3-3.148A7.885 7.885 0 0 0 10 1.364a8.368 8.368 0 0 0-3.352.682 8.659 8.659 0 0 0-4.6 4.6A8.368 8.368 0 0 0 1.364 10H0Z"
		/>
	</svg>
);

export const ConfigurationsSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
	>
		<path
			fill="#FFF"
			d="m7.763 20-.474-3.158a7.152 7.152 0 0 1-2.237-1.289l-2.947 1.342L0 13.184l2.658-1.974a5.119 5.119 0 0 1-.079-.592A7.869 7.869 0 0 1 2.553 10a7.587 7.587 0 0 1 .105-1.21L0 6.816l2.105-3.684 2.921 1.316a7.262 7.262 0 0 1 1.079-.737 6.633 6.633 0 0 1 1.158-.526L7.763 0h4.158l.474 3.184c.402.148.793.323 1.171.526.377.198.727.446 1.039.737l3-1.316 2.079 3.684L17 8.763A7.574 7.574 0 0 1 17.105 10c0 .175-.009.368-.026.579-.017.21-.044.43-.079.658l2.684 1.947-2.105 3.711-2.974-1.342a8.963 8.963 0 0 1-1.053.75c-.36.225-.75.398-1.158.513L11.921 20H7.763Zm2.053-7.026A2.966 2.966 0 0 0 12.789 10a2.964 2.964 0 0 0-2.974-2.974A2.965 2.965 0 0 0 6.842 10a2.965 2.965 0 0 0 2.974 2.974Zm0-1.211a1.752 1.752 0 1 1 1.25-.513 1.7 1.7 0 0 1-1.25.513ZM8.71 18.816h2.237l.395-2.947a5.978 5.978 0 0 0 1.566-.632c.5-.295.965-.648 1.382-1.053l2.737 1.184 1.052-1.868-2.421-1.789c.07-.316.127-.61.171-.882.044-.274.066-.551.066-.829a5.646 5.646 0 0 0-.237-1.684L18.105 6.5l-1.052-1.868-2.763 1.184a5.579 5.579 0 0 0-1.342-1.105 4.152 4.152 0 0 0-1.632-.579l-.342-2.947H8.711l-.342 2.947c-.564.1-1.107.296-1.605.579-.51.296-.971.669-1.368 1.105L2.632 4.632 1.579 6.5 4 8.289c-.072.273-.13.55-.171.829a5.877 5.877 0 0 0 0 1.75c.044.28.101.561.171.842L1.579 13.5l1.053 1.868 2.737-1.184c.403.425.868.784 1.381 1.066.51.276 1.054.483 1.618.618l.342 2.948Z"
		/>
	</svg>
);

export const CustomRulesSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={20}
		fill="none"
	>
		<path
			fill="#FFF"
			d="M3.975 15.75h8.05v-1.5h-8.05v1.5Zm0-4.25h8.05V10h-8.05v1.5ZM1.5 20c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-17C0 1.1.15.75.45.45.75.15 1.1 0 1.5 0h9.025L16 5.475V18.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-13ZM9.775 6.15V1.5H1.5v17h13V6.15H9.775Z"
		/>
	</svg>
);

export const RoleSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={20}
		fill="none"
	>
		<path
			fill="#FFF"
			d="M1.5 19.998a1.5 1.5 0 0 1-1.5-1.5V3.884a1.5 1.5 0 0 1 1.5-1.5h5.337A1.884 1.884 0 0 1 7.264.752a1.957 1.957 0 0 1 3.083 0 1.885 1.885 0 0 1 .427 1.632h5.337a1.5 1.5 0 0 1 1.5 1.5v14.614a1.5 1.5 0 0 1-1.5 1.5H1.5ZM8.808 2.64a.753.753 0 0 0 .777-.777.767.767 0 0 0-.475-.717.782.782 0 0 0-.859.173.767.767 0 0 0-.22.544.753.753 0 0 0 .777.777ZM1.166 18.003a12.634 12.634 0 0 1 3.459-2.293 10.084 10.084 0 0 1 4.184-.868c1.44-.013 2.867.283 4.184.868a12.634 12.634 0 0 1 3.459 2.293V3.883a.356.356 0 0 0-.337-.336H1.5a.355.355 0 0 0-.337.337l.003 14.119Zm7.668-5.363a3.316 3.316 0 0 0 3.342-3.342 3.317 3.317 0 0 0-3.342-3.342 3.183 3.183 0 0 0-2.358.972 3.248 3.248 0 0 0-.959 2.37 3.248 3.248 0 0 0 .959 2.37 3.181 3.181 0 0 0 2.358.972ZM2.2 18.832h13.215v-.207a10.44 10.44 0 0 0-3.122-1.956 9.395 9.395 0 0 0-3.484-.661 9.593 9.593 0 0 0-3.472.648A10.181 10.181 0 0 0 2.2 18.598v.234Zm6.658-7.383a2.12 2.12 0 0 1-1.541-.622 2.158 2.158 0 0 1 0-3.057 2.174 2.174 0 0 1 3.527.71 2.141 2.141 0 0 1-.47 2.347 2.09 2.09 0 0 1-1.514.622h-.002Z"
		/>
	</svg>
);

export const AddSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={14}
		height={14}
		fill="none"
	>
		<path
			fill="#fff"
			d="M6.034 14V7.966H0V6.034h6.034V0h1.931v6.034H14v1.931H7.966V14H6.034Z"
		/>
	</svg>
);

export const DeleteSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={80}
		height={80}
	>
		<path
			fill="#e74032"
			stroke="rgba(0,0,0,0)"
			d="M21.539 79.153a8.6 8.6 0 0 1-8.592-8.469L9.86 23.422H7.221a3.22 3.22 0 1 1 0-6.44h16.894V9.8A8.8 8.8 0 0 1 32.909 1h14.184a8.807 8.807 0 0 1 8.8 8.8v7.181h16.894a3.22 3.22 0 0 1 0 6.44H70.14l-3.087 47.263a8.591 8.591 0 0 1-8.584 8.469Zm-2.164-8.8v.209a2.163 2.163 0 0 0 2.16 2.158h36.93a2.157 2.157 0 0 0 2.152-2.158c0-.07 0-.139.006-.209L63.7 23.422H16.311Zm30.086-53.371V9.8a2.37 2.37 0 0 0-2.368-2.367H32.909a2.368 2.368 0 0 0-2.36 2.367v7.181ZM48.02 62.51a3.215 3.215 0 0 1-3.085-3.341l.859-21.331a3.22 3.22 0 0 1 6.434.261l-.859 21.325a3.222 3.222 0 0 1-3.215 3.092 1.1 1.1 0 0 1-.134-.006Zm-16.173.006a3.221 3.221 0 0 1-3.215-3.086l-.858-21.33a3.22 3.22 0 0 1 6.434-.261l.859 21.331a3.225 3.225 0 0 1-3.085 3.347Z"
			data-name="Union 159"
		/>
		<path
			fill="none"
			d="M0 0h80v80H0z"
			data-name="Rectangle 9533"
			opacity={0.5}
		/>
	</svg>
);

export const DeleteActionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={17}
		height={18}
		fill="none"
	>
		<path
			fill="#000"
			d="M4.457 18a1.981 1.981 0 0 1-1.98-1.951l-.71-10.885H1.16a.742.742 0 1 1 0-1.483h3.89V2.027A2.028 2.028 0 0 1 7.077 0h3.267a2.028 2.028 0 0 1 2.027 2.027v1.654h3.89a.742.742 0 0 1 0 1.483h-.61l-.71 10.885A1.98 1.98 0 0 1 12.963 18H4.457Zm-.5-2.027v.048a.5.5 0 0 0 .5.5h8.506a.5.5 0 0 0 .5-.5v-.048l.707-10.809H3.253l.704 10.809Zm6.93-12.292V2.027a.546.546 0 0 0-.544-.545H7.076a.545.545 0 0 0-.544.545v1.654h4.356Zm-.331 10.486a.742.742 0 0 1-.711-.77l.2-4.913a.742.742 0 0 1 1.482.06l-.2 4.912a.742.742 0 0 1-.74.712l-.031-.001Zm-3.725 0a.742.742 0 0 1-.74-.711l-.2-4.913a.742.742 0 0 1 1.482-.06l.2 4.913a.743.743 0 0 1-.711.771H6.83Z"
			opacity={1}
		/>
	</svg>
);

export const EditActionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={19}
		height={19}
		fill="none"
	>
		<path
			fill="#000"
			d="M.731 18.569a1.262 1.262 0 0 1-.3-1l.451-3.45c.043-.309.185-.596.404-.818l9.178-9.18.042-.044.044-.041L13.18 1.4a1.387 1.387 0 0 1 1.957 0l2.88 2.88a1.386 1.386 0 0 1 0 1.959l-11.9 11.89a1.43 1.43 0 0 1-.826.408l-3.449.45a1.264 1.264 0 0 1-1.111-.42Zm1.877-4.106-.353 2.7 2.7-.353 8.522-8.522L11.13 5.94l-8.522 8.523Zm12.11-7.418 1.787-1.784-2.347-2.35-1.785 1.79 2.344 2.344Z"
		/>
	</svg>
);

export const PermissionDetailsSvg = () => (
	<svg
		width="22"
		height="20"
		viewBox="0 0 22 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14.687 8.35802L18.9 4.11902L18.064 3.28302L14.691 6.65602L12.991 4.95602L12.155 5.82202L14.687 8.35802ZM0 20V18.209H14.328V20H0ZM15.522 11.343C14.7765 11.3451 14.038 11.1999 13.3489 10.9156C12.6598 10.6313 12.0337 10.2136 11.5066 9.68644C10.9795 9.15933 10.5618 8.53321 10.2775 7.8441C9.99316 7.15499 9.84789 6.41647 9.85 5.67102C9.84802 4.92566 9.99339 4.18725 10.2777 3.49825C10.5621 2.80926 10.9798 2.18326 11.5069 1.65625C12.034 1.12924 12.6601 0.711617 13.3492 0.427382C14.0382 0.143148 14.7766 -0.00208847 15.522 2.26972e-05C16.2674 -0.00208907 17.006 0.14318 17.6951 0.427477C18.3842 0.711773 19.0103 1.12949 19.5374 1.6566C20.0645 2.18372 20.4823 2.80983 20.7665 3.49895C21.0508 4.18806 21.1961 4.92657 21.194 5.67202C21.1961 6.41747 21.0508 7.15599 20.7665 7.8451C20.4823 8.53421 20.0645 9.16033 19.5374 9.68744C19.0103 10.2146 18.3842 10.6323 17.6951 10.9166C17.006 11.2009 16.2674 11.3451 15.522 11.343ZM0 9.85102V8.06002H7.821C7.91956 8.376 8.03916 8.68502 8.179 8.98502C8.31833 9.28369 8.46767 9.57236 8.627 9.85102H0ZM0 14.926V13.134H12.507C12.794 13.2562 13.0882 13.3608 13.388 13.447C13.6957 13.5364 14.01 13.6013 14.328 13.641V14.925L0 14.926Z"
			fill="#1543CC"
		/>
	</svg>
);

export const PermissionDetailsAdminSvg = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.37502 12.6078L13.4004 6.58244L12.2065 5.39765L7.37502 10.2292L4.981 7.83515L3.80798 9.01994L7.37502 12.6078ZM8.62935 17.2672C7.44228 17.2672 6.32419 17.0423 5.27506 16.5923C4.22595 16.1424 3.30946 15.5255 2.52558 14.7416C1.74172 13.9578 1.12483 13.0418 0.674896 11.9938C0.224965 10.9458 0 9.82819 0 8.64112C0 7.44017 0.224965 6.31513 0.674896 5.266C1.12483 4.21689 1.74111 3.30367 2.52375 2.52633C3.30638 1.749 4.22199 1.13361 5.2706 0.680167C6.31922 0.226722 7.43739 0 8.62512 0C9.82674 0 10.9526 0.226417 12.0026 0.67925C13.0527 1.13208 13.9661 1.74665 14.7428 2.52294C15.5196 3.29923 16.1345 4.21209 16.5876 5.26152C17.0407 6.31095 17.2672 7.43694 17.2672 8.6395C17.2672 9.82765 17.0405 10.9462 16.5871 11.9952C16.1336 13.0442 15.5182 13.9602 14.7409 14.7431C13.9636 15.526 13.0509 16.1424 12.0029 16.5923C10.9548 17.0423 9.83031 17.2672 8.62935 17.2672ZM8.62773 15.6169C10.5685 15.6169 12.2166 14.9382 13.572 13.5808C14.9274 12.2234 15.6051 10.5763 15.6051 8.6395C15.6051 6.69868 14.9274 5.05058 13.572 3.69521C12.2166 2.33983 10.5666 1.66215 8.62183 1.66215C6.69099 1.66215 5.04636 2.33983 3.68796 3.69521C2.32957 5.05058 1.65038 6.70065 1.65038 8.6454C1.65038 10.5762 2.32907 12.2209 3.68646 13.5793C5.04385 14.9377 6.69094 15.6169 8.62773 15.6169Z"
			fill="#009049"
		/>
	</svg>
);

export const ImageUploadSvg = () => (
	<svg
		width="19"
		height="17"
		viewBox="0 0 19 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.951 2.26667H14.2696L12.9461 0.252167C12.895 0.174475 12.8257 0.110799 12.7445 0.066805C12.6632 0.0228108 12.5725 -0.000137815 12.4804 6.22647e-07H6.51961C6.4275 -0.000137815 6.33679 0.0228108 6.25555 0.066805C6.1743 0.110799 6.10504 0.174475 6.05392 0.252167L4.72951 2.26667H2.04902C1.50559 2.26667 0.98441 2.48558 0.600144 2.87523C0.215878 3.26489 0 3.79338 0 4.34445V14.9222C0 15.4733 0.215878 16.0018 0.600144 16.3914C0.98441 16.7811 1.50559 17 2.04902 17H16.951C17.4944 17 18.0156 16.7811 18.3999 16.3914C18.7841 16.0018 19 15.4733 19 14.9222V4.34445C19 3.79338 18.7841 3.26489 18.3999 2.87523C18.0156 2.48558 17.4944 2.26667 16.951 2.26667ZM17.8824 14.9222C17.8824 15.1727 17.7842 15.4129 17.6096 15.59C17.4349 15.7672 17.198 15.8667 16.951 15.8667H2.04902C1.802 15.8667 1.56511 15.7672 1.39044 15.59C1.21577 15.4129 1.11765 15.1727 1.11765 14.9222V4.34445C1.11765 4.09396 1.21577 3.85374 1.39044 3.67662C1.56511 3.4995 1.802 3.4 2.04902 3.4H5.02941C5.12152 3.40014 5.21223 3.37719 5.29347 3.3332C5.37472 3.2892 5.44398 3.22553 5.4951 3.14783L6.81858 1.13333H12.1805L13.5049 3.14783C13.556 3.22553 13.6253 3.2892 13.7065 3.3332C13.7878 3.37719 13.8785 3.40014 13.9706 3.4H16.951C17.198 3.4 17.4349 3.4995 17.6096 3.67662C17.7842 3.85374 17.8824 4.09396 17.8824 4.34445V14.9222ZM9.5 5.28889C8.72633 5.28889 7.97003 5.52153 7.32674 5.95739C6.68345 6.39326 6.18207 7.01277 5.886 7.73758C5.58993 8.46239 5.51246 9.25996 5.6634 10.0294C5.81433 10.7989 6.18689 11.5057 6.73396 12.0604C7.28103 12.6152 7.97804 12.9929 8.73685 13.146C9.49566 13.2991 10.2822 13.2205 10.997 12.9203C11.7118 12.62 12.3227 12.1116 12.7525 11.4593C13.1823 10.807 13.4118 10.0401 13.4118 9.25556C13.4118 8.20353 12.9996 7.19459 12.266 6.4507C11.5324 5.70681 10.5375 5.28889 9.5 5.28889ZM9.5 12.0889C8.94738 12.0889 8.40716 11.9227 7.94767 11.6114C7.48818 11.3001 7.13005 10.8575 6.91857 10.3398C6.70709 9.8221 6.65176 9.25241 6.75957 8.7028C6.86738 8.15319 7.1335 7.64834 7.52426 7.25209C7.91502 6.85584 8.41289 6.58599 8.9549 6.47666C9.4969 6.36734 10.0587 6.42345 10.5693 6.6379C11.0798 6.85235 11.5162 7.2155 11.8232 7.68144C12.1302 8.14738 12.2941 8.69518 12.2941 9.25556C12.2941 10.007 11.9997 10.7277 11.4757 11.259C10.9517 11.7904 10.241 12.0889 9.5 12.0889Z"
			fill="#999999"
		/>
	</svg>
);

export const DefaultUserSvg = () => (
	<svg
		width="51"
		height="51"
		viewBox="0 0 51 51"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M42.5694 34.8895C40.3377 32.4715 37.6294 30.5418 34.6152 29.2219C31.601 27.9021 28.3461 27.2207 25.0556 27.2207C21.765 27.2207 18.5101 27.9021 15.4959 29.2219C12.4817 30.5418 9.77341 32.4715 7.54167 34.8895C7.19711 35.2705 7.00436 35.7647 7 36.2784V44.6117C7.0073 45.1595 7.23002 45.6822 7.61993 46.067C8.00984 46.4517 8.53558 46.6673 9.08333 46.6673H41.0278C41.5803 46.6673 42.1102 46.4478 42.5009 46.0571C42.8916 45.6664 43.1111 45.1365 43.1111 44.584V36.2506C43.1 35.7466 42.9077 35.2634 42.5694 34.8895Z"
			fill="#8B8B8B"
		/>
		<path
			d="M25.0543 24.4444C30.4237 24.4444 34.7765 20.0917 34.7765 14.7222C34.7765 9.35279 30.4237 5 25.0543 5C19.6848 5 15.332 9.35279 15.332 14.7222C15.332 20.0917 19.6848 24.4444 25.0543 24.4444Z"
			fill="#8B8B8B"
		/>
	</svg>
);

export const ToastSuccessSvg = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={20}
			height={21}
			fill="none"
		>
			<path
				fill="#fff"
				d="m8.542 14.723 6.98-6.98-1.384-1.371-5.596 5.596L5.77 9.195l-1.358 1.372 4.131 4.156Zm1.453 5.397c-1.375 0-2.67-.26-3.885-.782a10.066 10.066 0 0 1-3.185-2.144 10.073 10.073 0 0 1-2.143-3.182A9.739 9.739 0 0 1 0 10.128c0-1.39.26-2.694.782-3.909a9.95 9.95 0 0 1 2.141-3.173c.907-.9 1.967-1.613 3.182-2.139A9.684 9.684 0 0 1 9.99.12c1.392 0 2.696.262 3.912.786a10.096 10.096 0 0 1 3.174 2.136c.9.899 1.612 1.956 2.137 3.172A9.764 9.764 0 0 1 20 10.126a9.691 9.691 0 0 1-.788 3.887 10.23 10.23 0 0 1-2.138 3.183 9.951 9.951 0 0 1-3.172 2.142 9.798 9.798 0 0 1-3.907.782Zm-.002-1.912c2.248 0 4.157-.786 5.727-2.358 1.57-1.572 2.355-3.48 2.355-5.724 0-2.248-.785-4.156-2.355-5.726-1.57-1.57-3.481-2.355-5.734-2.355-2.236 0-4.141.785-5.714 2.355-1.574 1.57-2.36 3.48-2.36 5.733 0 2.237.786 4.142 2.358 5.715 1.572 1.573 3.48 2.36 5.723 2.36Z"
			/>
		</svg>
	);
};

export const ToastErrorSvg = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={20}
			height={21}
			fill="none"
		>
			<path
				d="M7.12531 15.1784L10.6358 11.668L14.1462 15.1784L15.2688 14.0558L11.7584 10.5454L15.2688 7.03494L14.1462 5.91234L10.6358 9.42279L7.12531 5.91234L6.00271 7.03494L9.51316 10.5454L6.00271 14.0558L7.12531 15.1784ZM10.6376 20.5386C9.2627 20.5386 7.96765 20.278 6.75249 19.7569C5.53734 19.2357 4.4758 18.5212 3.56787 17.6133C2.65995 16.7054 1.94542 15.6444 1.42429 14.4305C0.903147 13.2166 0.642578 11.9222 0.642578 10.5473C0.642578 9.15625 0.903147 7.85315 1.42429 6.63799C1.94542 5.42284 2.65924 4.36509 3.56575 3.46473C4.47223 2.56438 5.53276 1.85159 6.74733 1.32639C7.96189 0.801179 9.25703 0.538574 10.6327 0.538574C12.0245 0.538574 13.3285 0.800824 14.5448 1.32532C15.761 1.84983 16.819 2.56165 17.7186 3.4608C18.6183 4.35995 19.3306 5.41728 19.8554 6.6328C20.3802 7.84832 20.6426 9.15252 20.6426 10.5454C20.6426 11.9216 20.38 13.2172 19.8548 14.4322C19.3296 15.6472 18.6168 16.7081 17.7164 17.6149C16.8161 18.5217 15.7589 19.2357 14.545 19.7569C13.3311 20.278 12.0287 20.5386 10.6376 20.5386ZM10.6358 18.627C12.8837 18.627 14.7927 17.8409 16.3626 16.2687C17.9324 14.6965 18.7174 12.7887 18.7174 10.5454C18.7174 8.29741 17.9324 6.38848 16.3626 4.8186C14.7927 3.24872 12.8815 2.46378 10.6289 2.46378C8.3925 2.46378 6.48759 3.24872 4.91421 4.8186C3.34083 6.38848 2.55415 8.29969 2.55415 10.5522C2.55415 12.7886 3.34025 14.6936 4.91247 16.2669C6.48468 17.8403 8.39245 18.627 10.6358 18.627Z"
				fill="#fff"
			/>
		</svg>
	);
};

export const SortSvgTop = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={10}
			height={14}
			fill="none"
		>
			<path
				fill="#7A828A"
				d="m0 4.99.873.893L4.366 2.39v10.936h1.247V2.39l3.514 3.514L10 5.01 4.99 0 0 4.99Z"
			/>
		</svg>
	);
};

export const SortSvgBottom = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={10}
			height={14}
			fill="none"
		>
			<path
				fill="#7A828A"
				d="m10 8.337-.873-.894-3.493 3.493V0H4.387v10.936L.873 7.422 0 8.316l5.01 5.01L10 8.337Z"
			/>
		</svg>
	);
};

export const IntegrationConfigurationSvg = () => {
	return (
		<svg
			width="17"
			height="17"
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.33203 16.501C7.20912 16.501 7.09022 16.4574 6.99646 16.3779C6.9027 16.2985 6.8402 16.1886 6.82007 16.0674L6.50904 14.2002C6.28738 14.1248 6.07097 14.0344 5.86109 13.9307L4.30811 15.0176C4.20833 15.088 4.08677 15.1218 3.96509 15.1113C3.84341 15.1009 3.72941 15.0473 3.64307 14.9609L2.01709 13.332C1.93015 13.2451 1.87696 13.1304 1.86707 13.0078C1.85718 12.8852 1.89115 12.7629 1.96302 12.6631L3.05701 11.1328C2.95393 10.9193 2.86345 10.6997 2.78601 10.4756L0.92908 10.1455C0.809077 10.1248 0.700189 10.0628 0.621707 9.96973C0.543225 9.87661 0.50011 9.7585 0.500003 9.63672V7.33691C0.499597 7.21389 0.543135 7.09482 0.622683 7.00098C0.702232 6.90713 0.812657 6.84494 0.934085 6.8252L2.79102 6.5127C2.86934 6.29027 2.96056 6.0732 3.06409 5.86133L1.98011 4.31152C1.91018 4.21107 1.87777 4.08969 1.88855 3.96777C1.89934 3.84585 1.95259 3.73115 2.03907 3.64453L3.66504 2.02051C3.75141 1.93275 3.86633 1.87959 3.98902 1.86914C4.1117 1.85869 4.23414 1.89198 4.33411 1.96387L5.87305 3.06445C6.08224 2.96421 6.29734 2.87603 6.51709 2.80176L6.81702 0.9375C6.83751 0.815791 6.90036 0.705921 6.99439 0.625977C7.08842 0.546032 7.20764 0.501619 7.33106 0.500977H9.63111C9.75356 0.501131 9.87195 0.544969 9.96546 0.624023C10.059 0.703078 10.1216 0.811899 10.1421 0.932617L10.4701 2.80859C10.6907 2.88415 10.9065 2.9739 11.1161 3.07617L12.6581 1.96875C12.7582 1.89627 12.8808 1.86217 13.004 1.87207C13.1272 1.88197 13.2428 1.9359 13.3301 2.02344L14.9561 3.64941C15.0424 3.73571 15.0955 3.84913 15.1063 3.9707C15.1171 4.09228 15.0848 4.21431 15.015 4.31445L13.915 5.88086C14.0156 6.08778 14.1038 6.30021 14.1791 6.51758L16.062 6.8252C16.1836 6.84571 16.2941 6.9079 16.3739 7.00195C16.4537 7.096 16.4976 7.21554 16.498 7.33887V9.63867C16.4977 9.76092 16.4543 9.87921 16.3755 9.97266C16.2967 10.0661 16.1875 10.1295 16.067 10.1504L14.181 10.4795C14.1064 10.6968 14.0189 10.9102 13.9191 11.1172L15.0341 12.6631C15.106 12.7634 15.14 12.8858 15.1301 13.0088C15.1202 13.1318 15.0671 13.2474 14.9801 13.335L13.354 14.9639C13.2672 15.0502 13.1529 15.1038 13.0309 15.1143C12.9089 15.1247 12.7872 15.0909 12.687 15.0205L11.1271 13.9209C10.9158 14.0245 10.6984 14.1155 10.4761 14.1924L10.144 16.0713C10.1231 16.1915 10.0603 16.3004 9.9668 16.3789C9.87331 16.4574 9.75513 16.5002 9.63306 16.5L7.33203 16.501ZM6.07105 12.8711C6.40063 13.0547 6.75026 13.1993 7.11304 13.3027C7.20778 13.3296 7.29287 13.3835 7.3584 13.457C7.42393 13.5305 7.46719 13.6206 7.48304 13.7178L7.77307 15.4639H9.19702L9.50806 13.7051C9.52502 13.6095 9.56847 13.5202 9.63355 13.4482C9.69863 13.3763 9.78275 13.3243 9.8761 13.2979C10.2364 13.1928 10.5835 13.0476 10.911 12.8643C10.9962 12.8154 11.0935 12.7915 11.1917 12.7959C11.2898 12.8003 11.3847 12.8323 11.4651 12.8887L12.9291 13.917L13.9351 12.9102L12.891 11.4629C12.834 11.383 12.8006 11.2884 12.7948 11.1904C12.789 11.0924 12.8109 10.9953 12.858 10.9092C13.039 10.5832 13.1823 10.2373 13.285 9.87891C13.3117 9.78495 13.3644 9.7002 13.4369 9.63477C13.5094 9.56933 13.5989 9.52573 13.6951 9.50879L15.4611 9.2002V7.77637L13.7001 7.48926C13.603 7.47335 13.5124 7.43033 13.4386 7.36523C13.3648 7.30014 13.3109 7.21544 13.2831 7.12109C13.181 6.76179 13.0377 6.41527 12.8561 6.08887C12.8093 6.00364 12.7874 5.90663 12.7928 5.80957C12.7983 5.71251 12.831 5.61946 12.8871 5.54004L13.917 4.07324L12.911 3.06738L11.4661 4.10352C11.3865 4.16141 11.292 4.1955 11.1937 4.20117C11.0955 4.20685 10.9977 4.1841 10.912 4.13574C10.5832 3.95298 10.2347 3.80871 9.87305 3.70508C9.77991 3.67724 9.69628 3.6241 9.63135 3.55176C9.56642 3.47941 9.52266 3.39052 9.50501 3.29492L9.1991 1.53906H7.77503L7.49207 3.28027C7.47636 3.37816 7.43298 3.46891 7.36707 3.54297C7.30116 3.61703 7.2154 3.67128 7.12 3.69824C6.75949 3.80102 6.41166 3.9437 6.08301 4.12402C5.99711 4.17166 5.89946 4.19414 5.80139 4.18848C5.70333 4.18281 5.6089 4.14901 5.52906 4.0918L4.09107 3.06445L3.08203 4.07129L4.09607 5.51953C4.15227 5.59956 4.18475 5.69433 4.1897 5.79199C4.19465 5.88965 4.17184 5.98696 4.12403 6.07227C3.93945 6.40335 3.79385 6.75456 3.69007 7.11914C3.6622 7.21304 3.60853 7.29742 3.53516 7.3623C3.46179 7.42719 3.37163 7.47015 3.27503 7.48633L1.54004 7.77637V9.2002L3.2771 9.50879C3.37296 9.52524 3.46208 9.56865 3.5343 9.63379C3.60653 9.69893 3.65884 9.7833 3.68506 9.87695C3.79111 10.2401 3.93738 10.5902 4.1211 10.9209C4.16856 11.0073 4.19079 11.1056 4.18531 11.2041C4.17983 11.3026 4.14686 11.3969 4.09009 11.4775L3.06507 12.9111L4.07105 13.918L5.52307 12.9014C5.61014 12.8375 5.715 12.8019 5.823 12.8008C5.91013 12.8028 5.99542 12.8278 6.07105 12.8711ZM5.88501 8.50098C5.88581 7.80794 6.16144 7.14337 6.65149 6.65332C7.14154 6.16327 7.80599 5.88751 8.49903 5.88672C9.1919 5.88804 9.85602 6.16436 10.346 6.6543C10.8359 7.14423 11.1117 7.80811 11.113 8.50098C11.1117 9.19385 10.8359 9.85772 10.346 10.3477C9.85602 10.8376 9.1919 11.1139 8.49903 11.1152C7.80599 11.1144 7.14154 10.8387 6.65149 10.3486C6.16144 9.85858 5.88581 9.19401 5.88501 8.50098ZM6.922 8.50098C6.92306 8.91862 7.08966 9.31922 7.38526 9.61426C7.68086 9.9093 8.08138 10.0749 8.49903 10.0752C8.91623 10.0744 9.3162 9.90829 9.61121 9.61328C9.90622 9.31827 10.0722 8.91818 10.073 8.50098C10.0722 8.08377 9.90622 7.68368 9.61121 7.38867C9.3162 7.09366 8.91623 6.92755 8.49903 6.92676C8.08138 6.92702 7.68086 7.09266 7.38526 7.3877C7.08966 7.68273 6.92306 8.08333 6.922 8.50098Z"
				fill="#263238"
			/>
			<defs>
				<clipPath id="clip0_1237_11638">
					<rect
						width="17"
						height="17"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const IntegrationDisconnectSvg = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.205566 15.7948C0.139773 15.7292 0.0873763 15.6512 0.0517578 15.5654C0.0161393 15.4796 -0.00195312 15.3877 -0.00195312 15.2948C-0.00195312 15.2019 0.0161393 15.1099 0.0517578 15.0241C0.0873763 14.9383 0.139773 14.8603 0.205566 14.7948L3.6167 11.3838C3.74942 11.2514 3.92924 11.177 4.1167 11.177C4.30416 11.177 4.48397 11.2514 4.6167 11.3838C4.74909 11.5165 4.82324 11.6963 4.82324 11.8838C4.82324 12.0712 4.74909 12.251 4.6167 12.3838L1.20459 15.7948C1.13899 15.8604 1.06093 15.9123 0.975098 15.9475C0.889262 15.9826 0.797358 16.0004 0.70459 15.9998C0.61199 16.0003 0.520226 15.9825 0.43457 15.9473C0.348915 15.9121 0.271048 15.8602 0.205566 15.7948ZM3.58545 13.8148L4.55029 12.8498C5.05529 13.0704 5.61503 13.1342 6.15674 13.0329C6.69844 12.9316 7.1972 12.6699 7.58838 12.2818L9.12939 10.7408L10.0493 11.6608L8.50732 13.2018C8.13244 13.5764 7.6872 13.8733 7.19727 14.0755C6.70733 14.2776 6.18235 14.381 5.65234 14.3798C4.92512 14.3804 4.21125 14.1852 3.58545 13.8148ZM10.0854 13.4628V12.5998C10.0854 12.5167 10.1185 12.4371 10.1772 12.3784C10.2359 12.3197 10.3154 12.2868 10.3984 12.2868C10.4395 12.2868 10.4801 12.2949 10.5181 12.3106C10.556 12.3263 10.5906 12.3494 10.6196 12.3785C10.6486 12.4076 10.6714 12.4421 10.687 12.4801C10.7026 12.518 10.7106 12.5587 10.7104 12.5998V13.4668C10.7104 13.5495 10.6777 13.6289 10.6191 13.6874C10.5606 13.7459 10.4812 13.7788 10.3984 13.7788C10.3568 13.7792 10.3159 13.7713 10.2773 13.7555C10.2388 13.7398 10.2037 13.7165 10.1743 13.6871C10.1449 13.6577 10.1217 13.6227 10.106 13.5842C10.0902 13.5456 10.0821 13.5044 10.0825 13.4628H10.0854ZM12.3516 12.8058L11.7383 12.1928C11.6798 12.1341 11.647 12.0546 11.647 11.9718C11.647 11.8889 11.6798 11.8094 11.7383 11.7508C11.7968 11.6923 11.8763 11.6595 11.959 11.6595C12.0417 11.6595 12.1212 11.6923 12.1797 11.7508L12.7925 12.3648C12.8216 12.3937 12.8446 12.4282 12.8604 12.4661C12.8761 12.504 12.8843 12.5447 12.8843 12.5858C12.8843 12.6268 12.8761 12.6675 12.8604 12.7054C12.8446 12.7433 12.8216 12.7778 12.7925 12.8068C12.7635 12.8358 12.7288 12.8587 12.6909 12.8743C12.653 12.89 12.6123 12.8979 12.5713 12.8978C12.5299 12.898 12.489 12.89 12.4507 12.8742C12.4124 12.8584 12.3778 12.8351 12.3486 12.8058H12.3516ZM2.80127 7.49076L4.34131 5.94976L5.2627 6.86976L3.7207 8.41076C3.33272 8.80228 3.07082 9.30128 2.96973 9.84312C2.86863 10.385 2.93262 10.9447 3.15332 11.4498L2.18848 12.4138C1.73081 11.6414 1.54274 10.7389 1.65332 9.8479C1.7639 8.95692 2.16672 8.12785 2.79932 7.49076H2.80127ZM12.6206 10.7398C12.5379 10.7398 12.4584 10.7069 12.3999 10.6484C12.3414 10.5899 12.3086 10.5105 12.3086 10.4278C12.3085 10.3867 12.3164 10.346 12.332 10.3081C12.3477 10.2701 12.3704 10.2356 12.3994 10.2065C12.4284 10.1774 12.4631 10.1543 12.501 10.1386C12.5389 10.1229 12.5795 10.1148 12.6206 10.1148H13.4873C13.5703 10.1148 13.6503 10.1477 13.709 10.2064C13.7677 10.2651 13.8003 10.3447 13.8003 10.4278C13.8 10.5106 13.7672 10.59 13.7085 10.6484C13.6498 10.7069 13.5701 10.7398 13.4873 10.7398H12.6206ZM10.7437 9.13176L12.2847 7.59076C12.6729 7.19943 12.9344 6.70048 13.0356 6.1586C13.1369 5.61672 13.0732 5.05691 12.8525 4.55176L13.8174 3.58776C14.2749 4.36027 14.4633 5.26282 14.3525 6.1538C14.2418 7.04478 13.8383 7.87379 13.2056 8.51076L11.6646 10.0518L10.7437 9.13176ZM2.54346 5.91776C2.46071 5.91776 2.38127 5.88489 2.32275 5.82638C2.26424 5.76787 2.23145 5.68851 2.23145 5.60576C2.23145 5.5647 2.23963 5.52405 2.25537 5.48613C2.27111 5.44821 2.29416 5.41377 2.32324 5.38479C2.35232 5.3558 2.38684 5.33284 2.4248 5.31722C2.46277 5.3016 2.50338 5.29363 2.54443 5.29376H3.41162C3.45268 5.29363 3.49328 5.3016 3.53125 5.31722C3.56922 5.33284 3.60373 5.3558 3.63281 5.38479C3.66189 5.41377 3.68494 5.44821 3.70068 5.48613C3.71643 5.52405 3.72461 5.5647 3.72461 5.60576C3.72461 5.68851 3.69181 5.76787 3.6333 5.82638C3.57479 5.88489 3.49535 5.91776 3.4126 5.91776H2.54346ZM5.95557 4.34076L7.49658 2.79976C8.13343 2.16684 8.96253 1.76325 9.85352 1.65231C10.7445 1.54137 11.6468 1.72935 12.4194 2.18676L11.4546 3.15176C10.9494 2.93105 10.3895 2.8672 9.84766 2.96848C9.30578 3.06976 8.80686 3.3315 8.41553 3.71976L6.87549 5.26076L5.95557 4.34076ZM11.3926 4.61476C11.3269 4.54911 11.2748 4.47116 11.2393 4.38537C11.2037 4.29958 11.1855 4.20762 11.1855 4.11476C11.1855 4.0219 11.2037 3.92995 11.2393 3.84415C11.2748 3.75836 11.3269 3.68041 11.3926 3.61476L14.7993 0.205761C14.932 0.0733712 15.1119 -0.000976563 15.2993 -0.000976562C15.4868 -0.000976563 15.6666 0.0733712 15.7993 0.205761C15.865 0.271415 15.9171 0.349363 15.9526 0.435155C15.9882 0.520946 16.0068 0.612898 16.0068 0.705761C16.0068 0.798624 15.9882 0.890576 15.9526 0.976368C15.9171 1.06216 15.865 1.14011 15.7993 1.20576L12.3887 4.61776C12.3231 4.68336 12.245 4.73526 12.1592 4.77046C12.0733 4.80565 11.9814 4.82343 11.8887 4.82276C11.7953 4.82317 11.7024 4.80489 11.6162 4.769C11.53 4.7331 11.4522 4.68032 11.3867 4.61376L11.3926 4.61476ZM3.81348 4.26676L3.20068 3.65276C3.14218 3.59409 3.10938 3.51461 3.10938 3.43176C3.10938 3.34891 3.14218 3.26943 3.20068 3.21076C3.25936 3.15226 3.33853 3.11941 3.42139 3.11941C3.50424 3.11941 3.58391 3.15226 3.64258 3.21076L4.25537 3.82376C4.31387 3.88243 4.34668 3.96191 4.34668 4.04476C4.34668 4.12761 4.31387 4.20709 4.25537 4.26576C4.22632 4.29471 4.19222 4.31765 4.1543 4.33326C4.11638 4.34888 4.07568 4.35686 4.03467 4.35676C3.99268 4.35749 3.9506 4.34982 3.91162 4.33419C3.87264 4.31856 3.83748 4.2953 3.80762 4.26576L3.81348 4.26676ZM5.26758 3.38276V2.51476C5.26784 2.43209 5.30092 2.35289 5.35938 2.29444C5.41783 2.23598 5.49692 2.20302 5.57959 2.20276C5.62065 2.20263 5.66125 2.2106 5.69922 2.22622C5.73719 2.24184 5.7717 2.2648 5.80078 2.29379C5.82986 2.32277 5.85291 2.35721 5.86865 2.39513C5.88439 2.43305 5.89258 2.4737 5.89258 2.51476V3.38176C5.89271 3.42282 5.88476 3.4635 5.86914 3.50147C5.85352 3.53943 5.83025 3.57395 5.80127 3.60303C5.77228 3.6321 5.73811 3.65517 5.7002 3.67092C5.66228 3.68666 5.62162 3.69476 5.58057 3.69476C5.53884 3.69583 5.49734 3.68852 5.4585 3.67326C5.41965 3.65799 5.38433 3.63509 5.35449 3.60591C5.32465 3.57672 5.30079 3.54185 5.28467 3.50334C5.26855 3.46484 5.26059 3.4235 5.26074 3.38176L5.26758 3.38276Z"
				fill="#263238"
			/>

			<defs>
				<clipPath id="clip0_1237_11618">
					<rect
						width="16"
						height="16"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const CancelSubscriptionSvg = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0Z"
				fill="#263238"
				fillRule="evenodd"
			/>
			<path
				d="M10.5607 5.43934C10.9512 5.82987 10.9512 6.46303 10.5607 6.85355L9.41421 8L10.5607 9.14645C10.9512 9.53697 10.9512 10.1701 10.5607 10.5607C10.1701 10.9512 9.53697 10.9512 9.14645 10.5607L8 9.41421L6.85355 10.5607C6.46303 10.9512 5.82987 10.9512 5.43934 10.5607C5.04882 10.1701 5.04882 9.53697 5.43934 9.14645L6.58579 8L5.43934 6.85355C5.04882 6.46303 5.04882 5.82987 5.43934 5.43934C5.82987 5.04882 6.46303 5.04882 6.85355 5.43934L8 6.58579L9.14645 5.43934C9.53697 5.04882 10.1701 5.04882 10.5607 5.43934Z"
				fill="#263238"
			/>
		</svg>
	);
};
export const SyncNowSvg = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={16}
			height={16}
			fill="none"
		>
			<path
				fill="#344735"
				d="M.594 15.333v-1.375h2.979l-.344-.275c-.978-.779-1.688-1.627-2.131-2.543C.655 10.223.433 9.2.433 8.069c0-1.62.478-3.075 1.432-4.366.955-1.29 2.212-2.18 3.77-2.67v1.421a5.834 5.834 0 0 0-2.773 2.212 5.914 5.914 0 0 0-1.054 3.403c0 .962.18 1.799.539 2.51.359.71.844 1.324 1.455 1.844l.687.481v-2.841h1.375v5.27H.594Zm9.327-.343v-1.444a5.695 5.695 0 0 0 2.773-2.212 6.007 6.007 0 0 0 1.03-3.403c0-.733-.179-1.478-.538-2.234a7.147 7.147 0 0 0-1.41-2.005l-.664-.596v2.842H9.737V.667h5.271v1.375h-3.002l.344.32c.916.856 1.604 1.773 2.062 2.75.459.978.688 1.918.688 2.82 0 1.619-.474 3.078-1.421 4.376-.947 1.299-2.2 2.193-3.758 2.682Z"
			/>
		</svg>
	);
};

export const BlueAddSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={12}
		height={13}
		fill="none"
	>
		<path
			fill="#153FCD"
			d="M5.172 12.567V7.395H0V5.74h5.172V.567h1.655V5.74H12v1.656H6.828v5.172H5.172Z"
		/>
	</svg>
);

export const ClockSvg = () => (
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.765 11.9252L11.8192 10.8929L8.80436 7.85622V4.08766H7.40603V8.4263L10.765 11.9252ZM8.04879 16.1504C6.94884 16.1504 5.9132 15.9409 4.94188 15.5219C3.97057 15.103 3.12245 14.5312 2.39752 13.8065C1.67258 13.0818 1.10054 12.234 0.68142 11.2631C0.262296 10.2921 0.0527344 9.2568 0.0527344 8.15704C0.0527344 7.0573 0.263011 6.02136 0.683563 5.04923C1.1041 4.07711 1.67573 3.2297 2.39843 2.50699C3.12114 1.78429 3.96821 1.21084 4.93964 0.786663C5.91108 0.362481 6.94696 0.150391 8.04728 0.150391C9.1476 0.150391 10.1835 0.362481 11.1549 0.786663C12.1264 1.21084 12.9734 1.78429 13.6961 2.50699C14.4188 3.2297 14.9923 4.07677 15.4165 5.0482C15.8406 6.01964 16.0527 7.05552 16.0527 8.15584C16.0527 9.25617 15.8406 10.292 15.4165 11.2635C14.9923 12.2349 14.4188 13.082 13.6961 13.8047C12.9734 14.5274 12.1265 15.099 11.1554 15.5196C10.1843 15.9401 9.14874 16.1504 8.04879 16.1504ZM8.04172 14.6211C9.81807 14.6211 11.3406 13.9904 12.6094 12.7289C13.8782 11.4674 14.5126 9.94487 14.5126 8.16131C14.5126 6.37775 13.8787 4.8534 12.6109 3.58825C11.343 2.32312 9.82189 1.69055 8.04738 1.69055C6.2674 1.69055 4.74483 2.32268 3.47969 3.58692C2.21456 4.85115 1.58199 6.37413 1.58199 8.15584C1.58199 9.94304 2.21452 11.4674 3.47959 12.7289C4.74467 13.9904 6.26538 14.6211 8.04172 14.6211Z"
			fill="white"
		/>
	</svg>
);

export const TickMark = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={30}
		height={30}
		fill="none"
		viewBox="0 0 33 33"
	>
		<path
			fill="#009049"
			d="m5.986 18.596 1.618-1.617 4.672 4.672L25.04 8.893l1.617 1.617-14.382 14.383-6.29-6.297Z"
		/>
	</svg>
);

export const ConnectToQuickbooks = () => (
	<svg
		width="223"
		height="36"
		viewBox="0 0 223 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			width="223"
			height="36"
			rx="4"
			fill="#2CA01C"
		/>
		<path
			d="M35.3116 14.112C34.4156 12.928 32.6716 12.384 31.1996 12.384C27.7116 12.384 25.0556 14.672 25.0556 18.304C25.0556 21.84 27.5676 24.288 31.1036 24.288C33.0236 24.288 34.4956 23.552 35.4876 22.304L33.8716 21.168C33.2956 21.952 32.3356 22.48 31.1196 22.48C28.7836 22.48 27.2796 20.768 27.2796 18.304C27.2796 15.968 28.8636 14.16 31.1996 14.16C32.1116 14.16 33.1836 14.512 33.7756 15.328L35.3116 14.112ZM36.0087 20.128C36.0087 22.544 37.8647 24.224 40.1847 24.224C42.5047 24.224 44.3607 22.544 44.3607 20.128C44.3607 17.712 42.5047 16.096 40.1847 16.096C37.8647 16.096 36.0087 17.712 36.0087 20.128ZM37.9607 20.128C37.9607 18.928 38.6647 17.664 40.1847 17.664C41.7047 17.664 42.4087 18.928 42.4087 20.128C42.4087 21.328 41.7047 22.624 40.1847 22.624C38.6647 22.624 37.9607 21.328 37.9607 20.128ZM46.2223 24H48.1423V19.776C48.1423 18.752 48.7183 17.696 49.9343 17.696C51.1663 17.696 51.3743 18.832 51.3743 19.744V24H53.2943V19.2C53.2943 17.632 52.4623 16.096 50.4623 16.096C49.3263 16.096 48.4143 16.784 48.0783 17.552H48.0463V16.32H46.2223V24ZM55.5348 24H57.4548V19.776C57.4548 18.752 58.0308 17.696 59.2468 17.696C60.4788 17.696 60.6868 18.832 60.6868 19.744V24H62.6068V19.2C62.6068 17.632 61.7748 16.096 59.7748 16.096C58.6388 16.096 57.7268 16.784 57.3908 17.552H57.3588V16.32H55.5348V24ZM66.3193 19.392C66.3993 18.32 67.3113 17.536 68.4473 17.536C69.6953 17.536 70.2553 18.4 70.2553 19.392H66.3193ZM72.1753 20.256C72.1753 17.488 70.6073 16.096 68.4633 16.096C66.1433 16.096 64.3993 17.728 64.3993 20.208C64.3993 22.704 66.1593 24.224 68.5273 24.224C69.9833 24.224 71.0713 23.712 71.8233 22.688L70.5433 21.664C70.1113 22.272 69.4713 22.656 68.5113 22.656C67.3913 22.656 66.3993 21.856 66.3193 20.768H72.1593C72.1753 20.592 72.1753 20.432 72.1753 20.256ZM80.5948 17.296C79.9868 16.544 78.8188 16.096 77.6988 16.096C75.4428 16.096 73.5868 17.664 73.5868 20.16C73.5868 22.72 75.4748 24.224 77.7468 24.224C78.8828 24.224 79.9388 23.84 80.5788 23.152L79.3788 21.936C79.0108 22.384 78.3548 22.624 77.7628 22.624C76.3068 22.624 75.5868 21.36 75.5868 20.16C75.5868 18.96 76.2908 17.696 77.6988 17.696C78.3228 17.696 78.9788 18.016 79.2828 18.448L80.5948 17.296ZM82.0873 17.856V21.44C82.0873 22.912 82.5513 24.16 84.5833 24.16C85.0153 24.16 85.5273 24.08 85.8633 23.952L85.7993 22.448C85.5753 22.56 85.2393 22.608 84.9833 22.608C84.1353 22.608 83.9753 22.112 83.9753 21.424V17.856H85.8953V16.32H83.9753V14.096H82.0873V16.32H80.7433V17.856H82.0873ZM91.5248 17.856V21.44C91.5248 22.912 91.9888 24.16 94.0208 24.16C94.4528 24.16 94.9648 24.08 95.3008 23.952L95.2368 22.448C95.0128 22.56 94.6768 22.608 94.4208 22.608C93.5728 22.608 93.4128 22.112 93.4128 21.424V17.856H95.3328V16.32H93.4128V14.096H91.5248V16.32H90.1808V17.856H91.5248ZM96.2743 20.128C96.2743 22.544 98.1303 24.224 100.45 24.224C102.77 24.224 104.626 22.544 104.626 20.128C104.626 17.712 102.77 16.096 100.45 16.096C98.1303 16.096 96.2743 17.712 96.2743 20.128ZM98.2263 20.128C98.2263 18.928 98.9303 17.664 100.45 17.664C101.97 17.664 102.674 18.928 102.674 20.128C102.674 21.328 101.97 22.624 100.45 22.624C98.9303 22.624 98.2263 21.328 98.2263 20.128ZM122.792 22.368H119.992V22.336C121 21.616 122.008 20.224 122.008 18.192C122.008 14.752 119.464 12.384 115.992 12.384C112.52 12.384 109.928 14.752 109.928 18.192C109.928 21.872 112.344 24 115.96 24H122.792V22.368ZM115.992 14.192C118.28 14.192 119.816 15.888 119.816 18.192C119.816 20.608 118.2 22.24 115.96 22.24C113.688 22.24 112.136 20.608 112.136 18.192C112.136 15.888 113.8 14.192 115.992 14.192ZM131.121 16.32H129.201V20.544C129.201 21.568 128.625 22.624 127.409 22.624C126.177 22.624 125.969 21.488 125.969 20.576V16.32H124.049V21.12C124.049 22.688 124.881 24.224 126.881 24.224C128.017 24.224 128.929 23.536 129.265 22.768H129.297V24H131.121V16.32ZM133.457 24H135.377V16.32H133.457V24ZM133.185 13.712C133.185 14.32 133.697 14.864 134.401 14.864C135.105 14.864 135.649 14.368 135.649 13.712C135.649 13.056 135.105 12.56 134.401 12.56C133.697 12.56 133.185 13.104 133.185 13.712ZM144.267 17.296C143.659 16.544 142.491 16.096 141.371 16.096C139.115 16.096 137.259 17.664 137.259 20.16C137.259 22.72 139.147 24.224 141.419 24.224C142.555 24.224 143.611 23.84 144.251 23.152L143.051 21.936C142.683 22.384 142.027 22.624 141.435 22.624C139.979 22.624 139.259 21.36 139.259 20.16C139.259 18.96 139.963 17.696 141.371 17.696C141.995 17.696 142.651 18.016 142.955 18.448L144.267 17.296ZM145.551 24H147.471V20.064H147.519L150.559 24H153.103L149.567 19.792L152.895 16.32H150.431L147.519 19.552H147.471V11.904H145.551V24ZM154.303 24H158.383C160.527 24 162.671 23.168 162.671 20.704C162.671 19.184 161.647 18.224 160.223 18.032V18C161.391 17.648 162.191 16.8 162.191 15.52C162.191 13.456 160.431 12.672 158.719 12.672H154.303V24ZM156.319 14.336H157.935C159.455 14.336 160.175 14.736 160.175 15.744C160.175 16.72 159.455 17.28 158.111 17.28H156.319V14.336ZM156.319 19.008H158.207C159.839 19.008 160.655 19.424 160.655 20.608C160.655 22.096 159.167 22.304 158.127 22.304H156.319V19.008ZM164.118 20.128C164.118 22.544 165.974 24.224 168.294 24.224C170.614 24.224 172.47 22.544 172.47 20.128C172.47 17.712 170.614 16.096 168.294 16.096C165.974 16.096 164.118 17.712 164.118 20.128ZM166.07 20.128C166.07 18.928 166.774 17.664 168.294 17.664C169.814 17.664 170.518 18.928 170.518 20.128C170.518 21.328 169.814 22.624 168.294 22.624C166.774 22.624 166.07 21.328 166.07 20.128ZM173.884 20.128C173.884 22.544 175.74 24.224 178.06 24.224C180.38 24.224 182.236 22.544 182.236 20.128C182.236 17.712 180.38 16.096 178.06 16.096C175.74 16.096 173.884 17.712 173.884 20.128ZM175.836 20.128C175.836 18.928 176.54 17.664 178.06 17.664C179.58 17.664 180.284 18.928 180.284 20.128C180.284 21.328 179.58 22.624 178.06 22.624C176.54 22.624 175.836 21.328 175.836 20.128ZM184.129 24H186.049V20.064H186.097L189.137 24H191.681L188.145 19.792L191.473 16.32H189.009L186.097 19.552H186.049V11.904H184.129V24ZM198.147 17.264C197.523 16.48 196.371 16.096 195.267 16.096C193.747 16.096 192.211 16.832 192.211 18.544C192.211 19.984 193.347 20.448 194.483 20.72C195.651 20.992 196.243 21.184 196.243 21.824C196.243 22.512 195.571 22.736 195.011 22.736C194.179 22.736 193.459 22.32 193.043 21.776L191.779 22.96C192.515 23.776 193.747 24.224 194.931 24.224C196.611 24.224 198.131 23.536 198.131 21.664C198.131 20.16 196.787 19.648 195.651 19.376C194.579 19.12 193.987 18.96 193.987 18.368C193.987 17.76 194.611 17.536 195.219 17.536C195.923 17.536 196.563 17.92 196.899 18.368L198.147 17.264Z"
			fill="white"
		/>
	</svg>
);

export const ConnectToQuickbooksHover = () => (
	<svg
		width="223"
		height="36"
		viewBox="0 0 223 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			width="223"
			height="36"
			rx="4"
			fill="#2CA01C"
		/>
		<rect
			width="223"
			height="36"
			rx="4"
			fill="#108000"
			fillOpacity="0.5"
		/>
		<path
			d="M35.3116 14.112C34.4156 12.928 32.6716 12.384 31.1996 12.384C27.7116 12.384 25.0556 14.672 25.0556 18.304C25.0556 21.84 27.5676 24.288 31.1036 24.288C33.0236 24.288 34.4956 23.552 35.4876 22.304L33.8716 21.168C33.2956 21.952 32.3356 22.48 31.1196 22.48C28.7836 22.48 27.2796 20.768 27.2796 18.304C27.2796 15.968 28.8636 14.16 31.1996 14.16C32.1116 14.16 33.1836 14.512 33.7756 15.328L35.3116 14.112ZM36.0087 20.128C36.0087 22.544 37.8647 24.224 40.1847 24.224C42.5047 24.224 44.3607 22.544 44.3607 20.128C44.3607 17.712 42.5047 16.096 40.1847 16.096C37.8647 16.096 36.0087 17.712 36.0087 20.128ZM37.9607 20.128C37.9607 18.928 38.6647 17.664 40.1847 17.664C41.7047 17.664 42.4087 18.928 42.4087 20.128C42.4087 21.328 41.7047 22.624 40.1847 22.624C38.6647 22.624 37.9607 21.328 37.9607 20.128ZM46.2223 24H48.1423V19.776C48.1423 18.752 48.7183 17.696 49.9343 17.696C51.1663 17.696 51.3743 18.832 51.3743 19.744V24H53.2943V19.2C53.2943 17.632 52.4623 16.096 50.4623 16.096C49.3263 16.096 48.4143 16.784 48.0783 17.552H48.0463V16.32H46.2223V24ZM55.5348 24H57.4548V19.776C57.4548 18.752 58.0308 17.696 59.2468 17.696C60.4788 17.696 60.6868 18.832 60.6868 19.744V24H62.6068V19.2C62.6068 17.632 61.7748 16.096 59.7748 16.096C58.6388 16.096 57.7268 16.784 57.3908 17.552H57.3588V16.32H55.5348V24ZM66.3193 19.392C66.3993 18.32 67.3113 17.536 68.4473 17.536C69.6953 17.536 70.2553 18.4 70.2553 19.392H66.3193ZM72.1753 20.256C72.1753 17.488 70.6073 16.096 68.4633 16.096C66.1433 16.096 64.3993 17.728 64.3993 20.208C64.3993 22.704 66.1593 24.224 68.5273 24.224C69.9833 24.224 71.0713 23.712 71.8233 22.688L70.5433 21.664C70.1113 22.272 69.4713 22.656 68.5113 22.656C67.3913 22.656 66.3993 21.856 66.3193 20.768H72.1593C72.1753 20.592 72.1753 20.432 72.1753 20.256ZM80.5948 17.296C79.9868 16.544 78.8188 16.096 77.6988 16.096C75.4428 16.096 73.5868 17.664 73.5868 20.16C73.5868 22.72 75.4748 24.224 77.7468 24.224C78.8828 24.224 79.9388 23.84 80.5788 23.152L79.3788 21.936C79.0108 22.384 78.3548 22.624 77.7628 22.624C76.3068 22.624 75.5868 21.36 75.5868 20.16C75.5868 18.96 76.2908 17.696 77.6988 17.696C78.3228 17.696 78.9788 18.016 79.2828 18.448L80.5948 17.296ZM82.0873 17.856V21.44C82.0873 22.912 82.5513 24.16 84.5833 24.16C85.0153 24.16 85.5273 24.08 85.8633 23.952L85.7993 22.448C85.5753 22.56 85.2393 22.608 84.9833 22.608C84.1353 22.608 83.9753 22.112 83.9753 21.424V17.856H85.8953V16.32H83.9753V14.096H82.0873V16.32H80.7433V17.856H82.0873ZM91.5248 17.856V21.44C91.5248 22.912 91.9888 24.16 94.0208 24.16C94.4528 24.16 94.9648 24.08 95.3008 23.952L95.2368 22.448C95.0128 22.56 94.6768 22.608 94.4208 22.608C93.5728 22.608 93.4128 22.112 93.4128 21.424V17.856H95.3328V16.32H93.4128V14.096H91.5248V16.32H90.1808V17.856H91.5248ZM96.2743 20.128C96.2743 22.544 98.1303 24.224 100.45 24.224C102.77 24.224 104.626 22.544 104.626 20.128C104.626 17.712 102.77 16.096 100.45 16.096C98.1303 16.096 96.2743 17.712 96.2743 20.128ZM98.2263 20.128C98.2263 18.928 98.9303 17.664 100.45 17.664C101.97 17.664 102.674 18.928 102.674 20.128C102.674 21.328 101.97 22.624 100.45 22.624C98.9303 22.624 98.2263 21.328 98.2263 20.128ZM122.792 22.368H119.992V22.336C121 21.616 122.008 20.224 122.008 18.192C122.008 14.752 119.464 12.384 115.992 12.384C112.52 12.384 109.928 14.752 109.928 18.192C109.928 21.872 112.344 24 115.96 24H122.792V22.368ZM115.992 14.192C118.28 14.192 119.816 15.888 119.816 18.192C119.816 20.608 118.2 22.24 115.96 22.24C113.688 22.24 112.136 20.608 112.136 18.192C112.136 15.888 113.8 14.192 115.992 14.192ZM131.121 16.32H129.201V20.544C129.201 21.568 128.625 22.624 127.409 22.624C126.177 22.624 125.969 21.488 125.969 20.576V16.32H124.049V21.12C124.049 22.688 124.881 24.224 126.881 24.224C128.017 24.224 128.929 23.536 129.265 22.768H129.297V24H131.121V16.32ZM133.457 24H135.377V16.32H133.457V24ZM133.185 13.712C133.185 14.32 133.697 14.864 134.401 14.864C135.105 14.864 135.649 14.368 135.649 13.712C135.649 13.056 135.105 12.56 134.401 12.56C133.697 12.56 133.185 13.104 133.185 13.712ZM144.267 17.296C143.659 16.544 142.491 16.096 141.371 16.096C139.115 16.096 137.259 17.664 137.259 20.16C137.259 22.72 139.147 24.224 141.419 24.224C142.555 24.224 143.611 23.84 144.251 23.152L143.051 21.936C142.683 22.384 142.027 22.624 141.435 22.624C139.979 22.624 139.259 21.36 139.259 20.16C139.259 18.96 139.963 17.696 141.371 17.696C141.995 17.696 142.651 18.016 142.955 18.448L144.267 17.296ZM145.551 24H147.471V20.064H147.519L150.559 24H153.103L149.567 19.792L152.895 16.32H150.431L147.519 19.552H147.471V11.904H145.551V24ZM154.303 24H158.383C160.527 24 162.671 23.168 162.671 20.704C162.671 19.184 161.647 18.224 160.223 18.032V18C161.391 17.648 162.191 16.8 162.191 15.52C162.191 13.456 160.431 12.672 158.719 12.672H154.303V24ZM156.319 14.336H157.935C159.455 14.336 160.175 14.736 160.175 15.744C160.175 16.72 159.455 17.28 158.111 17.28H156.319V14.336ZM156.319 19.008H158.207C159.839 19.008 160.655 19.424 160.655 20.608C160.655 22.096 159.167 22.304 158.127 22.304H156.319V19.008ZM164.118 20.128C164.118 22.544 165.974 24.224 168.294 24.224C170.614 24.224 172.47 22.544 172.47 20.128C172.47 17.712 170.614 16.096 168.294 16.096C165.974 16.096 164.118 17.712 164.118 20.128ZM166.07 20.128C166.07 18.928 166.774 17.664 168.294 17.664C169.814 17.664 170.518 18.928 170.518 20.128C170.518 21.328 169.814 22.624 168.294 22.624C166.774 22.624 166.07 21.328 166.07 20.128ZM173.884 20.128C173.884 22.544 175.74 24.224 178.06 24.224C180.38 24.224 182.236 22.544 182.236 20.128C182.236 17.712 180.38 16.096 178.06 16.096C175.74 16.096 173.884 17.712 173.884 20.128ZM175.836 20.128C175.836 18.928 176.54 17.664 178.06 17.664C179.58 17.664 180.284 18.928 180.284 20.128C180.284 21.328 179.58 22.624 178.06 22.624C176.54 22.624 175.836 21.328 175.836 20.128ZM184.129 24H186.049V20.064H186.097L189.137 24H191.681L188.145 19.792L191.473 16.32H189.009L186.097 19.552H186.049V11.904H184.129V24ZM198.147 17.264C197.523 16.48 196.371 16.096 195.267 16.096C193.747 16.096 192.211 16.832 192.211 18.544C192.211 19.984 193.347 20.448 194.483 20.72C195.651 20.992 196.243 21.184 196.243 21.824C196.243 22.512 195.571 22.736 195.011 22.736C194.179 22.736 193.459 22.32 193.043 21.776L191.779 22.96C192.515 23.776 193.747 24.224 194.931 24.224C196.611 24.224 198.131 23.536 198.131 21.664C198.131 20.16 196.787 19.648 195.651 19.376C194.579 19.12 193.987 18.96 193.987 18.368C193.987 17.76 194.611 17.536 195.219 17.536C195.923 17.536 196.563 17.92 196.899 18.368L198.147 17.264Z"
			fill="white"
		/>
	</svg>
);

export const QuickbooksEmployee = () => (
	<svg
		width="15"
		height="14"
		viewBox="0 0 15 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.4698 0.0698242H8.37892C8.02755 0.0698242 7.74263 0.351669 7.74263 0.699243C7.74263 1.04682 8.02755 1.32866 8.37892 1.32866H11.9336L5.38368 7.80786C5.13513 8.05373 5.13513 8.45215 5.38368 8.69802C5.50782 8.82082 5.67079 8.88249 5.83349 8.88249C5.99618 8.88249 6.15915 8.82109 6.28356 8.69802L12.8335 2.21883V5.73513C12.8335 6.0827 13.1184 6.36455 13.4698 6.36455C13.8211 6.36455 14.1061 6.0827 14.1061 5.73513V0.699243C14.1061 0.351669 13.8211 0.0698242 13.4698 0.0698242Z"
			fill="#2C9F1C"
		/>
		<path
			d="M10.9237 6.36467C10.5724 6.36467 10.2875 6.64652 10.2875 6.99409V12.6597H1.37805V3.84673H7.10547C7.45684 3.84673 7.74176 3.56488 7.74176 3.21731C7.74176 2.86974 7.45684 2.58789 7.10547 2.58789H0.741758C0.390391 2.58789 0.105469 2.86974 0.105469 3.21731V13.2891C0.105469 13.6367 0.390391 13.9185 0.741758 13.9185H10.9235C11.2748 13.9185 11.5598 13.6367 11.5598 13.2891V6.99409C11.5598 6.64652 11.2748 6.36467 10.9235 6.36467H10.9237Z"
			fill="#2C9F1C"
		/>
	</svg>
);

export const QuickbooksEmployeeBlue = () => (
	<svg
		width="15"
		height="14"
		viewBox="0 0 15 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.4698 0.0698242H8.37892C8.02755 0.0698242 7.74263 0.351669 7.74263 0.699243C7.74263 1.04682 8.02755 1.32866 8.37892 1.32866H11.9336L5.38368 7.80786C5.13513 8.05373 5.13513 8.45215 5.38368 8.69802C5.50782 8.82082 5.67079 8.88249 5.83349 8.88249C5.99618 8.88249 6.15915 8.82109 6.28356 8.69802L12.8335 2.21883V5.73513C12.8335 6.0827 13.1184 6.36455 13.4698 6.36455C13.8211 6.36455 14.1061 6.0827 14.1061 5.73513V0.699243C14.1061 0.351669 13.8211 0.0698242 13.4698 0.0698242Z"
			fill="#1543CC"
		/>
		<path
			d="M10.9237 6.36467C10.5724 6.36467 10.2875 6.64652 10.2875 6.99409V12.6597H1.37805V3.84673H7.10547C7.45684 3.84673 7.74176 3.56488 7.74176 3.21731C7.74176 2.86974 7.45684 2.58789 7.10547 2.58789H0.741758C0.390391 2.58789 0.105469 2.86974 0.105469 3.21731V13.2891C0.105469 13.6367 0.390391 13.9185 0.741758 13.9185H10.9235C11.2748 13.9185 11.5598 13.6367 11.5598 13.2891V6.99409C11.5598 6.64652 11.2748 6.36467 10.9235 6.36467H10.9237Z"
			fill="#1543CC"
		/>
	</svg>
);

export const ExportSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={10}
		height={16}
		fill="none"
	>
		<path
			fill="#263238"
			d="M0 16v-1.5h10V16H0Zm4.25-4.25v-8.9L1.225 5.875l-1.05-1.05L5 0l4.825 4.825-1.05 1.05L5.75 2.85v8.9h-1.5Z"
		/>
	</svg>
);

export const DownArrowSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={12}
		height={7}
		fill="none"
	>
		<path
			fill="#27272E"
			d="M5.678 6.6 0 .922.922 0l4.756 4.755L10.434 0l.922.922L5.678 6.6Z"
		/>
	</svg>
);

export const HoursSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={17}
		height={16}
		fill="none"
	>
		<path
			fill="#485949"
			d="m11.091 11.775 1.054-1.033-3.014-3.036V3.937H7.732v4.339l3.36 3.499ZM8.375 16a7.76 7.76 0 0 1-3.107-.629 8.095 8.095 0 0 1-2.544-1.715 8.094 8.094 0 0 1-1.716-2.543 7.753 7.753 0 0 1-.63-3.106c0-1.1.211-2.136.632-3.108a8.11 8.11 0 0 1 1.715-2.542 8.19 8.19 0 0 1 2.54-1.72A7.68 7.68 0 0 1 8.374 0c1.1 0 2.137.212 3.108.636a8.191 8.191 0 0 1 2.541 1.72 8.19 8.19 0 0 1 1.72 2.542 7.68 7.68 0 0 1 .637 3.107 7.68 7.68 0 0 1-.636 3.108 8.19 8.19 0 0 1-1.72 2.541 8.116 8.116 0 0 1-2.541 1.715c-.972.42-2.007.631-3.107.631Zm-.007-1.53c1.776 0 3.299-.63 4.568-1.892 1.268-1.261 1.903-2.784 1.903-4.567 0-1.784-.634-3.308-1.902-4.573-1.268-1.265-2.789-1.898-4.563-1.898-1.78 0-3.303.632-4.568 1.897C2.54 4.7 1.908 6.224 1.908 8.005c0 1.788.633 3.312 1.898 4.573 1.265 1.262 2.786 1.893 4.562 1.893Z"
		/>
	</svg>
);

export const DownArrowRoundSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={26}
		height={26}
		fill="none"
	>
		<path
			fill="#B3B3B3"
			d="m13 17.031 5.406-5.406-1.343-1.313L13 14.375l-4.063-4.063-1.343 1.313L13 17.031Zm0 8.469c-1.708 0-3.323-.328-4.844-.984a12.678 12.678 0 0 1-3.984-2.688 12.678 12.678 0 0 1-2.688-3.984A12.095 12.095 0 0 1 .5 13c0-1.73.328-3.354.984-4.875a12.492 12.492 0 0 1 2.688-3.969 12.814 12.814 0 0 1 3.984-2.672A12.095 12.095 0 0 1 13 .5c1.73 0 3.354.328 4.875.984a12.623 12.623 0 0 1 3.969 2.672 12.622 12.622 0 0 1 2.672 3.969c.656 1.52.984 3.146.984 4.875 0 1.708-.328 3.323-.984 4.844a12.812 12.812 0 0 1-2.672 3.984 12.492 12.492 0 0 1-3.969 2.688c-1.52.656-3.146.984-4.875.984Zm0-1.875c2.958 0 5.469-1.037 7.531-3.11 2.063-2.072 3.094-4.578 3.094-7.515 0-2.958-1.031-5.469-3.094-7.531C18.47 3.406 15.958 2.375 13 2.375c-2.938 0-5.443 1.031-7.516 3.094C3.411 7.53 2.375 10.042 2.375 13c0 2.938 1.036 5.443 3.11 7.516 2.072 2.073 4.577 3.109 7.515 3.109Z"
		/>
	</svg>
);

export const SplitSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={17}
		fill="none"
	>
		<path
			fill="#000"
			d="M7.208 16.5V8.887L1.682 3.36v2.895H0V.5h5.755v1.682h-2.87L8.89 8.187V16.5H7.208Zm3.032-9.08L9.062 6.24l4.041-4.06h-2.858V.5H16v5.755h-1.682V3.372L10.24 7.42Z"
		/>
	</svg>
);

export const CalculatorSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={19}
		height={19}
		fill="none"
	>
		<path
			fill="#153FCD"
			d="M4.967 15.9h1.25v-2.2h2.2v-1.25h-2.2v-2.2h-1.25v2.2h-2.2v1.25h2.2v2.2Zm5.375-.875h5.025V13.8h-5.025v1.225Zm0-2.675h5.025V11.1h-5.025v1.25Zm.925-4.075 1.525-1.525 1.525 1.525.9-.9-1.525-1.525 1.525-1.525-.9-.9-1.525 1.525-1.525-1.525-.9.9 1.525 1.525-1.525 1.525.9.9Zm-8.125-1.8h4.9v-1.25h-4.9v1.25ZM1.617 18.6c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05v-15c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h15c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v15c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15Zm0-1.5h15v-15h-15v15Z"
		/>
	</svg>
);

export const RightSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={7}
		height={12}
		fill="none"
	>
		<path
			fill="#344735"
			d="m6.6 5.915-5.162 5.162L.6 10.24l4.323-4.324L.6 1.592l.838-.839L6.6 5.915Z"
		/>
	</svg>
);

export const LeftSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={7}
		height={11}
		fill="none"
	>
		<path
			fill="#344735"
			d="M.6 5.239 5.76.077 6.6.916 2.277 5.239 6.6 9.562l-.839.839L.6 5.239Z"
		/>
	</svg>
);

export const TickSmall = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		width={17}
		className="tick-small"
		height={18}
	>
		<path
			d="M.3.8h16.4v16.4H.3z"
			style={{
				fill: '#fff',
			}}
		/>
		<path
			d="M.4 10.3 1.7 9l3.7 3.7 10-10L16.6 4 5.3 15.3l-4.9-5z"
			style={{
				fill: '#009049',
			}}
		/>
	</svg>
);

export const TickSmallSplit = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		width={17}
		className="tick-small"
		height={18}
	>
		<path
			d="M.3.8h16.4v16.4H.3z"
			style={{
				fill: '#e4e4e4',
			}}
		/>
		<path
			d="M.4 10.3 1.7 9l3.7 3.7 10-10L16.6 4 5.3 15.3l-4.9-5z"
			style={{
				fill: '#009049',
			}}
		/>
	</svg>
);

export const AddInRoundSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={19}
		height={18}
		fill="none"
	>
		<path
			fill="#000"
			d="M8.61 13.467h1.393V9.788h3.7V8.395h-3.7V4.538H8.609v3.857H4.775v1.393H8.61v3.679ZM9.245 18a8.741 8.741 0 0 1-3.502-.706A9.116 9.116 0 0 1 2.88 15.36 9.112 9.112 0 0 1 .95 12.498a8.752 8.752 0 0 1-.707-3.506c0-1.245.236-2.414.707-3.506A8.989 8.989 0 0 1 2.88 2.633 9.228 9.228 0 0 1 5.743.709 8.73 8.73 0 0 1 9.25 0c1.246 0 2.415.236 3.508.708a9.1 9.1 0 0 1 2.853 1.923 9.084 9.084 0 0 1 1.924 2.857 8.758 8.758 0 0 1 .708 3.509 8.717 8.717 0 0 1-.709 3.503 9.184 9.184 0 0 1-1.924 2.858 9.066 9.066 0 0 1-2.856 1.931A8.73 8.73 0 0 1 9.246 18Zm.005-1.51c2.076 0 3.841-.73 5.295-2.188 1.454-1.46 2.181-3.23 2.181-5.31 0-2.077-.726-3.842-2.177-5.296-1.45-1.454-3.222-2.18-5.313-2.18-2.071 0-3.836.725-5.296 2.176-1.46 1.451-2.189 3.222-2.189 5.313 0 2.071.73 3.836 2.189 5.296 1.459 1.46 3.229 2.19 5.31 2.19Z"
		/>
	</svg>
);

export const SubInRoundSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={19}
		height={18}
		fill="none"
	>
		<path
			fill="#999"
			d="M4.807 9.691h8.865v-1.51H4.807v1.51ZM9.24 18a8.738 8.738 0 0 1-3.491-.706A9.1 9.1 0 0 1 2.88 15.36 9.102 9.102 0 0 1 .95 12.494a8.733 8.733 0 0 1-.707-3.49c0-1.249.236-2.42.707-3.514A8.978 8.978 0 0 1 2.88 2.633 9.217 9.217 0 0 1 5.747.709 8.711 8.711 0 0 1 9.238 0c1.249 0 2.42.236 3.515.708a9.087 9.087 0 0 1 2.857 1.923 9.084 9.084 0 0 1 1.924 2.857 8.773 8.773 0 0 1 .708 3.515 8.713 8.713 0 0 1-.709 3.492 9.217 9.217 0 0 1-1.924 2.867 8.976 8.976 0 0 1-2.856 1.932A8.787 8.787 0 0 1 9.24 18Zm0-1.51c2.083 0 3.852-.73 5.306-2.188 1.454-1.46 2.181-3.226 2.181-5.3 0-2.083-.727-3.852-2.18-5.306-1.455-1.454-3.225-2.18-5.31-2.18-2.071 0-3.836.726-5.296 2.18-1.46 1.454-2.189 3.224-2.189 5.31 0 2.07.73 3.835 2.189 5.295s3.225 2.19 5.299 2.19Z"
		/>
	</svg>
);

export const PayPeriodSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={27}
		height={27}
		fill="none"
	>
		<path
			fill="#FFF"
			fillRule="evenodd"
			d="M18.307 26.268a.895.895 0 0 1-.894-.894v-1.1a.9.9 0 0 1 .259-.637l2.013-2.013a3.485 3.485 0 0 0 1.03-2.48v-1.68h-5.71a.895.895 0 0 1 0-1.789h10.111V2.056H2.693v13.62h2.614v-.207a3.1 3.1 0 0 1 3.095-3.095 3.1 3.1 0 0 1 3.095 3.095v2.534l.138.049a3.1 3.1 0 0 1 2.063 2.92.895.895 0 0 1-1.788 0c0-.721-.586-1.307-1.307-1.307a.895.895 0 0 1-.894-.895V15.47a1.308 1.308 0 0 0-2.614 0v3.676c.001.936.366 1.817 1.03 2.479l2.013 2.014c.166.167.26.398.259.634v1.102a.895.895 0 0 1-1.789 0v-.736l-1.756-1.744a5.258 5.258 0 0 1-1.545-3.75v-1.681H1.799a.895.895 0 0 1-.894-.894V1.162c0-.493.4-.894.894-.894h24.212c.493 0 .894.4.894.894v15.407a.895.895 0 0 1-.894.895h-3.508v1.68a5.262 5.262 0 0 1-1.547 3.75l-1.755 1.744v.736a.895.895 0 0 1-.894.894ZM9.709 8.178a4.2 4.2 0 0 0 4.196 4.196A4.2 4.2 0 0 0 18.1 8.178a4.2 4.2 0 0 0-4.196-4.196 4.2 4.2 0 0 0-4.196 4.196Zm1.788 0a2.41 2.41 0 0 1 2.408-2.407 2.41 2.41 0 0 1 2.407 2.407 2.41 2.41 0 0 1-2.407 2.407 2.41 2.41 0 0 1-2.408-2.407Zm-4.402 0a.894.894 0 1 1-1.788 0 .894.894 0 0 1 1.788 0Zm15.408 0a.894.894 0 1 1-1.789 0 .894.894 0 0 1 1.789 0Z"
			clipRule="evenodd"
		/>
	</svg>
);

export const Previous = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={6}
		height={12}
		fill="none"
	>
		<path
			fill="#344735"
			d="M0 5.671 5.162.211 6 1.098 1.677 5.671 6 10.244l-.838.887L0 5.67Z"
		/>
	</svg>
);

export const Next = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={6}
		height={12}
		fill="none"
	>
		<path
			fill="#344735"
			d="m6 6.329-5.162 5.46L0 10.902l4.323-4.573L0 1.756.838.87 6 6.33Z"
		/>
	</svg>
);

export const EmployeeCost = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
	>
		<defs>
			<clipPath id="a">
				<path
					fill="none"
					d="M0 0h20v20H0z"
					data-name="Rectangle 10592"
				/>
			</clipPath>
		</defs>
		<g
			clipPath="url(#a)"
			data-name="Group 5625"
		>
			<path
				fillRule="evenodd"
				d="M9.855 2.215a7.776 7.776 0 1 0 7.44 5.487.708.708 0 0 1 1.353-.417A9.19 9.19 0 1 1 11.755 1a.708.708 0 1 1-.292 1.385 7.818 7.818 0 0 0-1.608-.17M19.14 1.5a.707.707 0 0 1 0 1l-3.774 3.774a.708.708 0 0 1-1 0l-1.888-1.886a.708.708 0 0 1 1-1l1.387 1.387L18.14 1.5a.708.708 0 0 1 1 0ZM9.855 3.631a.708.708 0 0 1 .708.708v1.2h.025a2.629 2.629 0 0 1 2.629 2.629.708.708 0 1 1-1.415 0 1.213 1.213 0 0 0-1.213-1.213h-.025V9.3h.076a2.578 2.578 0 0 1 0 5.156h-.076v1.2a.708.708 0 0 1-1.415 0v-1.2h-.076a2.578 2.578 0 0 1-2.578-2.578.708.708 0 0 1 1.415 0 1.163 1.163 0 0 0 1.163 1.163h.076V10.72h-.063a2.591 2.591 0 0 1 0-5.181h.063v-1.2a.708.708 0 0 1 .706-.708Zm-.708 3.324h-.063a1.175 1.175 0 0 0 0 2.351h.063Zm1.415 3.766v2.325h.076a1.163 1.163 0 0 0 0-2.325Z"
				data-name="Path 6379"
			/>
		</g>
	</svg>
);

export const JournalEntries = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
	>
		<defs>
			<clipPath id="a">
				<path
					fill="none"
					d="M0 0h20v20H0z"
					data-name="Rectangle 10596"
				/>
			</clipPath>
		</defs>
		<g data-name="Group 5633">
			<g
				fillRule="evenodd"
				clipPath="url(#a)"
				data-name="Group 5632"
			>
				<path
					d="M18.293 4.046v11.911a3.189 3.189 0 0 1-3.189 3.189H4.897a3.189 3.189 0 0 1-3.189-3.189V4.046A3.189 3.189 0 0 1 4.897.857h10.206a3.189 3.189 0 0 1 3.189 3.189m-1.276 0a1.913 1.913 0 0 0-1.914-1.914H4.897a1.913 1.913 0 0 0-1.914 1.914v11.911a1.913 1.913 0 0 0 1.914 1.914h10.206a1.913 1.913 0 0 0 1.914-1.914Z"
					data-name="Path 6388"
				/>
				<path
					d="M14.206 4.259a.638.638 0 1 1 0 1.276H5.748a.638.638 0 1 1 0-1.276Z"
					data-name="Path 6389"
				/>
				<path
					d="M14.253 7.661a.638.638 0 1 1 0 1.276h-8.5a.638.638 0 1 1 0-1.276Z"
					data-name="Path 6390"
				/>
				<path
					d="M14.253 11.063a.638.638 0 1 1 0 1.276h-8.5a.638.638 0 1 1 0-1.276Z"
					data-name="Path 6391"
				/>
				<path
					d="M14.253 14.465a.638.638 0 1 1 0 1.276h-8.5a.638.638 0 1 1 0-1.276Z"
					data-name="Path 6392"
				/>
			</g>
		</g>
	</svg>
);
export const TimeLogs = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
	>
		<defs>
			<clipPath id="a">
				<path
					fill="none"
					d="M0 0h20v20H0z"
					data-name="Rectangle 10593"
				/>
			</clipPath>
		</defs>
		<g
			clipPath="url(#a)"
			data-name="Group 5627"
		>
			<path
				d="M19.329 5.987 14.013.671a.663.663 0 0 0-.469-.195H6.456A2.435 2.435 0 0 0 4.02 2.912v4.456a6.417 6.417 0 0 0 2.879 12.155h10.188a2.435 2.435 0 0 0 2.436-2.436V6.456a.663.663 0 0 0-.195-.47m-5.12-3.242 3.048 3.048h-3.048ZM1.805 13.101a5.094 5.094 0 1 1 5.094 5.094 5.1 5.1 0 0 1-5.094-5.094m15.282 5.094h-6.29A6.412 6.412 0 0 0 5.349 6.876V2.912a1.108 1.108 0 0 1 1.107-1.107h6.42v4.651a.669.669 0 0 0 .664.664h4.651v9.967a1.108 1.108 0 0 1-1.107 1.107m-7.828-3.676a.668.668 0 0 1 0 .939.663.663 0 0 1-.939 0L6.43 13.57a.663.663 0 0 1-.195-.47v-2.657a.664.664 0 0 1 1.329 0v2.383Z"
				data-name="Path 6380"
			/>
		</g>
	</svg>
);

export const CostAllocation = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
	>
		<defs>
			<clipPath id="a">
				<path
					fill="none"
					d="M0 0h20v20H0z"
					data-name="Rectangle 10594"
				/>
			</clipPath>
		</defs>
		<g
			clipPath="url(#a)"
			data-name="Group 5629"
		>
			<path
				d="M11.664 11.133a1.821 1.821 0 0 0 1.856-1.414 1.664 1.664 0 0 0-1.28-1.836c-.519-.192-1-.4-1.161-.469a.251.251 0 0 1-.083-.231.385.385 0 0 1 .308-.3 1.385 1.385 0 0 1 1.138.265.587.587 0 1 0 .754-.9 2.551 2.551 0 0 0-2.222-.483 1.56 1.56 0 0 0-1.13 1.26 1.414 1.414 0 0 0 .631 1.4.584.584 0 0 0 .081.044c.025.011.618.275 1.286.522.138.051.584.24.532.531a.676.676 0 0 1-.7.448 1.446 1.446 0 0 1-1.063-.444.586.586 0 1 0-.868.787 2.6 2.6 0 0 0 1.921.82Z"
				data-name="Path 6381"
			/>
			<path
				d="M19.853 13.513a1.784 1.784 0 0 0-2.278-1.068 3.365 3.365 0 0 0 .042-.531v-1.883a7.653 7.653 0 0 0-3.765-6.591l.993-2.648A.586.586 0 0 0 14.297 0H8.829a.586.586 0 0 0-.55.792l.994 2.648a7.652 7.652 0 0 0-3.765 6.591v.885a5.152 5.152 0 0 0-.87.232l-1.209.44-.054-.15a.586.586 0 0 0-.746-.35l-2.2.8a.586.586 0 0 0-.386.551v6.974A.586.586 0 0 0 .629 20h2.534a.585.585 0 0 0 .2-.035l2.2-.8a.586.586 0 0 0 .385-.545l5.006.688A2.93 2.93 0 0 0 12.716 19l6.289-3.3a1.783 1.783 0 0 0 .848-2.187Zm-6.4-12.341-.734 1.953h-2.313l-.732-1.953Zm-6.772 8.86a6.444 6.444 0 0 1 3.46-5.732h2.842a6.444 6.444 0 0 1 3.462 5.735v1.883a2.121 2.121 0 0 1-.387 1.229l-2.136 1a1.758 1.758 0 0 0-1.436-1.487l-1.595-.281a3.986 3.986 0 0 1-1.562-.643 5.189 5.189 0 0 0-2.65-.891Zm-3.62 8.8h-1.85V12.85l1.266-.461 2.138 5.873Zm15.4-4.163-6.289 3.3a1.759 1.759 0 0 1-1.055.185l-5.577-.766-1.711-4.699 1.21-.439a4.021 4.021 0 0 1 3.63.45 5.148 5.148 0 0 0 2.018.821l1.595.281a.586.586 0 0 1-.2 1.154L8.353 14.3a.586.586 0 1 0-.2 1.154l3.726.657a1.754 1.754 0 0 0 1.467-.412l4.576-2.133a.613.613 0 0 1 .542 1.1Z"
				data-name="Path 6382"
			/>
		</g>
	</svg>
);

export const ToolTipInfo = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={22}
		height={22}
	>
		<defs>
			<clipPath id="a">
				<path d="M0 0h22v22H0z" />
			</clipPath>
		</defs>
		<g
			clipPath="url(#a)"
			data-name="Artboard \u2013 5"
		>
			<path
				fill="#fff"
				d="M0 0h22v22H0z"
			/>
			<path
				fill="#494949"
				stroke="rgba(0,0,0,0)"
				strokeMiterlimit={10}
				d="M0 11A11.012 11.012 0 0 1 11 0a11.013 11.013 0 0 1 11 11 11.012 11.012 0 0 1-11 11A11.012 11.012 0 0 1 0 11Zm1.817 0A9.194 9.194 0 0 0 11 20.183 9.194 9.194 0 0 0 20.184 11 9.194 9.194 0 0 0 11 1.816 9.194 9.194 0 0 0 1.817 11Zm5.853 6.358v-.807h1.323a.493.493 0 0 0 .493-.493v-5.3a.46.46 0 0 0-.46-.46H7.669v-.807h4.844V16a.549.549 0 0 0 .549.549h1.065v.807Zm1.211-11.3a1.816 1.816 0 0 1 1.817-1.817 1.816 1.816 0 0 1 1.817 1.817 1.816 1.816 0 0 1-1.817 1.817 1.816 1.816 0 0 1-1.817-1.82Z"
				data-name="Union 55"
			/>
		</g>
	</svg>
);

export const EmailWhite = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={14}
		fill="none"
	>
		<path
			fill="currentColor"
			d="M1.658 14c-.453 0-.843-.163-1.17-.489A1.596 1.596 0 0 1 0 12.341V1.67C0 1.213.163.82.489.492A1.59 1.59 0 0 1 1.659 0h14.02c.457 0 .85.164 1.178.492.328.329.492.721.492 1.178v10.672c0 .453-.164.843-.492 1.17-.328.325-.721.488-1.178.488H1.66Zm7.01-6.239-7.01-4.668v9.249H15.68V3.093L8.67 7.761Zm0-1.528 6.927-4.563H1.763l6.906 4.563Zm-7.01-3.14V1.67v10.672-9.249Z"
		/>
	</svg>
);

export const ExportPdfWhite = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={12}
		height={18}
		fill="none"
	>
		<path
			fill="currentColor"
			d="M0 18v-1.688h11.25V18H0Zm4.781-4.781V3.206L1.378 6.61.197 5.43 5.625 0l5.428 5.428L9.872 6.61 6.469 3.206V13.22H4.78Z"
		/>
	</svg>
);

export const MaximizeIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={21}
		height={20}
		fill="none"
	>
		<path
			fill="#263238"
			d="M2.643 17.585v-6.42h1.419v4.001L15.393 3.835h-4v-1.42h6.419v6.42h-1.42v-4l-11.33 11.33h4v1.42h-6.42Z"
		/>
	</svg>
);

export const MinimizeIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
	>
		<g
			fill="#263238"
			clipPath="url(#a)"
		>
			<path d="M3.016 12.027h3.97L1 18.017l.987.983 5.987-5.986v3.97h1.408v-6.362H3.016v1.405ZM19 1.987 18.017 1l-5.982 5.982v-3.97h-1.413v6.37h6.37V7.97h-3.974L19 1.987Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path
					fill="#fff"
					d="M1 1h18v18H1z"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const EditTimeSheet = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={16}
		fill="none"
	>
		<path
			fill="#FF5F15"
			d="M.277 15.616a1.121 1.121 0 0 1-.267-.889l.401-3.065c.038-.275.164-.53.359-.727l8.156-8.157.038-.04.039-.037L11.339.36a1.233 1.233 0 0 1 1.74 0l2.56 2.56a1.232 1.232 0 0 1 0 1.74L5.062 15.228a1.27 1.27 0 0 1-.734.361l-3.065.401a1.097 1.097 0 0 1-.987-.373Zm1.668-3.649-.314 2.4 2.4-.314 7.573-7.573-2.086-2.087-7.573 7.574Zm10.76-6.592 1.59-1.585-2.086-2.088-1.586 1.59 2.083 2.083Z"
		/>
	</svg>
);

export const ClearFilterSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={31}
		height={31}
		fill="none"
	>
		<path
			fill="#000"
			d="M25.17 4.557h-8.506c-.703 0-1.157.454-1.157 1.157 0 .703.454 1.158 1.157 1.158h8.767v2.636l-2.487 2.486c-.468.469-.468 1.149 0 1.617.255.255.474.35.809.35.334 0 .557-.098.808-.35l2.41-2.41c.5-.5.775-1.139.775-1.8V7.13a2.579 2.579 0 0 0-2.575-2.575v.001ZM6.13.653a1.143 1.143 0 0 0-.808-.349c-.297 0-.583.124-.809.349-.468.469-.468 1.148 0 1.617L6.8 4.557H5.322a2.579 2.579 0 0 0-2.576 2.576V9.4c0 .662.275 1.302.775 1.8l7.732 7.733v8.614c0 .924.396 1.679 1.146 2.185.497.247.892.39 1.43.39.377 0 .765-.128 1.175-.264l2.813-1.406c.944-.541 1.422-1.323 1.422-2.323v-7.196l.97-.97 4.153 4.154c.255.255.474.349.809.349.334 0 .553-.095.808-.349.469-.468.469-1.148 0-1.617L6.13.653ZM17.698 17.24c-.5.5-.775 1.139-.775 1.801v7.25l-3.356 1.677V19.04c0-.662-.275-1.302-.774-1.8L5.062 9.51V6.872h3.804c.04 0 .08-.001.117-.005l.12-.009 9.489 9.49-.893.892h-.001Z"
		/>
	</svg>
);

export const PreviewSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={21}
		height={15}
		fill="none"
	>
		<path
			fill="#000000"
			d="M10.662 11.395c1.083 0 2.002-.379 2.759-1.137.756-.758 1.134-1.678 1.134-2.76 0-1.083-.38-2.003-1.137-2.76-.758-.755-1.678-1.133-2.761-1.133-1.083 0-2.002.379-2.759 1.137-.756.758-1.134 1.678-1.134 2.76 0 1.083.38 2.003 1.137 2.759.758.756 1.678 1.134 2.761 1.134Zm-.007-1.416a2.38 2.38 0 0 1-1.754-.725 2.401 2.401 0 0 1-.72-1.758c0-.69.241-1.275.724-1.755a2.401 2.401 0 0 1 1.759-.72c.69 0 1.274.242 1.754.725.48.482.72 1.068.72 1.758a2.38 2.38 0 0 1-.724 1.755c-.483.48-1.069.72-1.759.72Zm.005 4.521c-2.26 0-4.302-.647-6.126-1.94C2.709 11.266 1.349 9.58.452 7.5c.897-2.08 2.257-3.766 4.082-5.06C6.358 1.147 8.4.5 10.659.5c2.26 0 4.302.647 6.126 1.94 1.825 1.294 3.185 2.98 4.082 5.06-.897 2.08-2.257 3.766-4.082 5.06-1.824 1.293-3.866 1.94-6.126 1.94Zm-.004-1.5c1.848 0 3.547-.501 5.095-1.502A9.748 9.748 0 0 0 19.287 7.5a9.756 9.756 0 0 0-3.533-3.998A9.18 9.18 0 0 0 10.663 2c-1.848 0-3.547.5-5.094 1.5A9.912 9.912 0 0 0 2.009 7.5a9.92 9.92 0 0 0 3.556 3.998A9.18 9.18 0 0 0 10.656 13Z"
		/>
	</svg>
);

export const EditJournalSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={16}
		height={16}
		fill="none"
	>
		<path
			fill="#000000"
			d="M.277 15.616a1.121 1.121 0 0 1-.267-.889l.401-3.065c.038-.275.164-.53.359-.727l8.156-8.157.038-.04.039-.037L11.339.36a1.233 1.233 0 0 1 1.74 0l2.56 2.56a1.232 1.232 0 0 1 0 1.74L5.062 15.228a1.27 1.27 0 0 1-.734.361l-3.065.401a1.097 1.097 0 0 1-.987-.373Zm1.668-3.649-.314 2.4 2.4-.314 7.573-7.573-2.086-2.087-7.573 7.574Zm10.76-6.592 1.59-1.585-2.086-2.088-1.586 1.59 2.083 2.083Z"
		/>
	</svg>
);

export const SyncLogsSvg = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.855517 18.3145V16.6427H4.34844L3.43153 15.7384C2.49166 14.8238 1.8105 13.8183 1.38805 12.7219C0.965612 11.6255 0.754395 10.5146 0.754395 9.38929C0.754395 7.3787 1.3421 5.57002 2.51751 3.96323C3.6929 2.35644 5.23465 1.24742 7.14274 0.636163V2.40442C5.71109 2.9682 4.56708 3.8855 3.7107 5.15633C2.85432 6.42716 2.42613 7.83713 2.42613 9.38624C2.42613 10.312 2.60058 11.2153 2.94949 12.0962C3.29841 12.9771 3.84667 13.7913 4.59427 14.5389L5.42503 15.3697V12.0732H7.09677V18.3145H0.855517ZM12.5683 17.9927V16.2245C13.9999 15.6607 15.1449 14.7431 16.0032 13.4716C16.8615 12.2001 17.2906 10.7894 17.2906 9.23953C17.2906 8.31589 17.1152 7.41363 16.7644 6.53273C16.4136 5.65183 15.8644 4.83759 15.1168 4.08998L14.286 3.25923V6.5557H12.6143V0.314453H18.8555V1.98619H15.3626L16.2795 2.89046C17.2092 3.81784 17.8887 4.8264 18.3182 5.91614C18.7477 7.00589 18.9624 8.11436 18.9624 9.24153C18.9624 11.2518 18.3737 13.0601 17.1964 14.6664C16.0191 16.2727 14.4764 17.3815 12.5683 17.9927Z"
			fill="#FFF"
		/>
	</svg>
);

export const ExpenseGroupsSvg = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.5 4.5C2.5 3.11929 3.61929 2 5 2H14C15.3807 2 16.5 3.11929 16.5 4.5V14.5C16.5 15.8807 15.3807 17 14 17H5C3.61929 17 2.5 15.8807 2.5 14.5V4.5Z"
			stroke="#FFF"
			strokeWidth="1.5"
			fill="none"
		/>
		<path
			d="M6.5 7.5H12.5M6.5 10.5H12.5M6.5 13.5H10.5"
			stroke="#FFF"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
		<circle cx="4.5" cy="7.5" r="1" fill="#FFF" />
		<circle cx="4.5" cy="10.5" r="1" fill="#FFF" />
		<circle cx="4.5" cy="13.5" r="1" fill="#FFF" />
	</svg>
);

export const ActiveRule = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={19}
		fill="none"
	>
		<path
			fill="#009049"
			d="m7.688 13.643 6.281-6.281-1.244-1.235-5.037 5.036-2.496-2.495L3.97 9.903l3.718 3.74ZM8.996 18.5a8.777 8.777 0 0 1-3.497-.703 9.061 9.061 0 0 1-2.866-1.93 9.066 9.066 0 0 1-1.93-2.864A8.765 8.765 0 0 1 0 9.508c0-1.252.235-2.425.704-3.519A8.956 8.956 0 0 1 2.63 3.134a9.204 9.204 0 0 1 2.863-1.925A8.715 8.715 0 0 1 8.991.5c1.253 0 2.426.236 3.521.708a9.087 9.087 0 0 1 2.856 1.922 9.08 9.08 0 0 1 1.923 2.855A8.788 8.788 0 0 1 18 9.506a8.721 8.721 0 0 1-.709 3.498 9.208 9.208 0 0 1-1.925 2.865 8.959 8.959 0 0 1-2.854 1.928 8.82 8.82 0 0 1-3.516.703Zm-.002-1.72c2.023 0 3.741-.708 5.154-2.123 1.413-1.415 2.12-3.132 2.12-5.15 0-2.024-.707-3.742-2.12-5.155-1.413-1.413-3.133-2.12-5.16-2.12-2.013 0-3.727.707-5.144 2.12C2.428 5.765 1.72 7.485 1.72 9.512c0 2.013.708 3.727 2.123 5.143 1.415 1.417 3.132 2.125 5.15 2.125Z"
		/>
	</svg>
);

export const InactiveRule = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={19}
		fill="none"
	>
		<path
			fill="#E74133"
			d="m5.834 13.676 3.16-3.16 3.16 3.16 1.01-1.01-3.16-3.16 3.16-3.16-1.01-1.01-3.16 3.16-3.16-3.16-1.01 1.01 3.16 3.16-3.16 3.16 1.01 1.01ZM8.996 18.5a8.777 8.777 0 0 1-3.497-.703 9.061 9.061 0 0 1-2.866-1.93 9.066 9.066 0 0 1-1.93-2.864A8.765 8.765 0 0 1 0 9.508c0-1.252.235-2.425.704-3.519A8.956 8.956 0 0 1 2.63 3.134a9.204 9.204 0 0 1 2.863-1.925A8.715 8.715 0 0 1 8.991.5c1.253 0 2.426.236 3.521.708a9.087 9.087 0 0 1 2.856 1.922 9.08 9.08 0 0 1 1.923 2.855A8.788 8.788 0 0 1 18 9.506a8.721 8.721 0 0 1-.709 3.498 9.208 9.208 0 0 1-1.925 2.865 8.959 8.959 0 0 1-2.854 1.928 8.82 8.82 0 0 1-3.516.703Zm-.002-1.72c2.023 0 3.741-.708 5.154-2.123 1.413-1.415 2.12-3.132 2.12-5.15 0-2.024-.707-3.742-2.12-5.155-1.413-1.413-3.133-2.12-5.16-2.12-2.013 0-3.727.707-5.144 2.12C2.428 5.765 1.72 7.485 1.72 9.512c0 2.013.708 3.727 2.123 5.143 1.415 1.417 3.132 2.125 5.15 2.125Z"
		/>
	</svg>
);

export const CopyActionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={32}
		height={32}
		fill="none"
	>
		<path
			fill="#000"
			d="M14.595 16.487H13v13.01c0 .405.15.762.447 1.056.299.298.655.447 1.057.447h13.009v-1.595H14.595V16.487Z"
		/>
		<path
			fill="#000"
			d="M30.553 13.447A1.451 1.451 0 0 0 29.497 13h-11.51c-.406 0-.758.15-1.056.447a1.467 1.467 0 0 0-.448 1.057v11.51c0 .405.15.757.448 1.051.294.294.65.448 1.056.448h11.506c.405 0 .762-.15 1.056-.448a1.46 1.46 0 0 0 .447-1.056V14.504c0-.406-.149-.763-.447-1.057h.004Zm-1.147 1.148v11.327H18.078V14.595h11.328Z"
		/>
	</svg>
);

export const EditRuleActionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={32}
		height={32}
		fill="none"
	>
		<path
			fill="#000"
			d="M13.73 30.568a1.263 1.263 0 0 1-.3-1l.452-3.449c.042-.31.184-.597.404-.819l9.178-9.179.042-.045.044-.041 2.629-2.635a1.387 1.387 0 0 1 1.958 0l2.88 2.881a1.386 1.386 0 0 1 0 1.958l-11.9 11.891a1.43 1.43 0 0 1-.826.407l-3.45.451a1.264 1.264 0 0 1-1.111-.42Zm1.878-4.106-.353 2.7 2.7-.353 8.522-8.522-2.347-2.348-8.522 8.523Zm12.109-7.418 1.788-1.784-2.347-2.349-1.785 1.789 2.344 2.344Z"
		/>
	</svg>
);

export const DeleteRuleActionSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={32}
		height={32}
		fill="none"
	>
		<path
			fill="#000"
			d="M17.456 31a1.981 1.981 0 0 1-1.98-1.951l-.71-10.885h-.607a.741.741 0 1 1 0-1.483h3.89v-1.654A2.027 2.027 0 0 1 20.076 13h3.267a2.028 2.028 0 0 1 2.027 2.027v1.654h3.89a.743.743 0 0 1 0 1.483h-.61l-.71 10.885A1.98 1.98 0 0 1 25.962 31h-8.506Zm-.5-2.027v.048a.5.5 0 0 0 .5.5h8.506a.5.5 0 0 0 .5-.5v-.048l.707-10.809H16.252l.704 10.809Zm6.93-12.292v-1.654a.546.546 0 0 0-.544-.545h-3.267a.545.545 0 0 0-.544.545v1.654h4.356Zm-.331 10.486a.742.742 0 0 1-.711-.77l.2-4.913a.742.742 0 0 1 1.482.06l-.2 4.912a.743.743 0 0 1-.74.712l-.031-.001Zm-3.725 0a.742.742 0 0 1-.74-.711l-.2-4.913a.742.742 0 0 1 1.482-.06l.2 4.913a.743.743 0 0 1-.711.771h-.031Z"
		/>
	</svg>
);

export const UpArrowSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={28}
		height={28}
		fill="none"
	>
		<path
			fill="#fff"
			d="M0 0h28v28H0V0z"
		/>
		<path
			fill="#000"
			d="m15.201 25.818.01-20.784L19.1 8.916c.223.23.529.358.848.358 1.055-.009 1.572-1.288.821-2.027l-5.917-5.924a1.184 1.184 0 0 0-1.676 0L7.259 7.248c-1.159 1.119.566 2.834 1.679 1.669l3.905-3.905-.01 20.807a1.186 1.186 0 0 0 1.198 1.206 1.181 1.181 0 0 0 1.169-1.206Z"
		/>
	</svg>
);
export const KeySvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={19}
		height={19}
		fill="none"
	>
		<path
			fill="#fff"
			d="M.857.082h18v18h-18z"
		/>
		<path
			fill="#000"
			d="M18.104 8.96c0-2.048-1.361-3.707-3.041-3.707-1.384 0-2.551 1.126-2.92 2.667H1.603V10h.656v1.924h4.136V10h5.748c.369 1.542 1.536 2.668 2.92 2.668 1.68 0 3.041-1.66 3.041-3.707Zm-3.041 1.802c-.536 0-1.135-.769-1.136-1.799V8.96c0-1.032.6-1.802 1.136-1.802.536 0 1.136.77 1.136 1.802v.001c0 1.03-.6 1.8-1.136 1.8Z"
		/>
		<path
			fill="#000"
			d="M10.649 9.997h-.852V7.918h.852V9.997Z"
		/>
		<path
			fill="#000"
			fillRule="evenodd"
			d="M12.146 9.998c.368 1.542 1.536 2.668 2.92 2.668 1.68 0 3.041-1.66 3.041-3.707l-1.905.001c0 1.03-.6 1.8-1.136 1.8-.536 0-1.135-.768-1.136-1.798l-12.324.01v1.026h.656v1.924h4.136V9.999h5.748Z"
			clipRule="evenodd"
		/>
		<path
			fill="#000"
			d="M10.648 9.998h-.852V8.965h.852v1.033Z"
		/>
		<path
			fill="#fff"
			d="m4.767 12.052-.47-.002-.494-.001-.006-2.264.964.003.006 2.264Z"
		/>
	</svg>
);
